<template>
  <div>
    <a-spin :spinning="spinning">
      <h2 v-if="profileId == 0">Create Recipe - {{product.name}}</h2>
      <h2 v-else>Update Recipe - {{product.name}}</h2>
      <hr>
      <div class="row no-gutters">
        <div class="col-md-2">
          <a-collapse v-model="activeKey" :accordion="accordion">
            <a-collapse-panel header="Basic" key="1">
              <a-menu @click="handleClick" class="ml-3" :defaultSelectedKeys="['1']" :selectedKeys="basicSelectedKeys">
                <a-menu-item key="1" :class="selectedBasicKey('1')">
                  Info
                </a-menu-item>
                <a-menu-item key="2" :class="selectedBasicKey('2')">
                  Classification
                </a-menu-item>
                <a-menu-item key="3" :class="selectedBasicKey('3')">
                  Other
                </a-menu-item>
              </a-menu>
            </a-collapse-panel>
            <a-collapse-panel header="Advanced" key="2">
              <a-menu @click="handleClick" class="ml-3" :defaultSelectedKeys="advanceSelectedKey" :selectedKeys="advanceSelectedKeys">
                <a-menu-item key="1" :class="selectedAdvanceKey('1')">
                  Alternate Barcode
                </a-menu-item>
                <a-menu-item key="2" :class="selectedAdvanceKey('2')">
                  Product Series
                </a-menu-item>
                <a-menu-item key="3" :class="selectedAdvanceKey('3')">
                  Site Price
                </a-menu-item>
                <a-menu-item key="4" :class="selectedAdvanceKey('4')">
                  Site Product
                </a-menu-item>
                <a-menu-item key="5" :class="selectedAdvanceKey('5')">
                  Re-order Control
                </a-menu-item>
                <a-menu-item key="6" :class="selectedAdvanceKey('6')">
                  Selling
                </a-menu-item>
                <a-menu-item key="7" :class="selectedAdvanceKey('7')">
                  SC/PWD
                </a-menu-item>
                <a-menu-item key="8" :class="selectedAdvanceKey('8')">
                  CLP
                </a-menu-item>
                <a-menu-item key="9" :class="selectedAdvanceKey('9')">
                  Commission
                </a-menu-item>
                <a-menu-item key="10" :class="selectedAdvanceKey('10')">
                  Shelf Code
                </a-menu-item>
                <a-menu-item key="11" :class="selectedAdvanceKey('11')">
                  Dimension
                </a-menu-item>
              </a-menu>
            </a-collapse-panel>
          </a-collapse>
        </div>
        <div class="col-md-10">
          <div class="card mb-3 border-0">
            <base-alert v-if="errors.length || tableErrors.length" type="danger">
              <b>You have the following error(s):</b>
              <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
              <li v-for="error in tableErrors" v-bind:key="error">{{ error }}</li>
            </base-alert>

            <form id="form-proper">
              
              <div v-if="activeKey == '1' && basicKey == '1'" class="card-body">
                <h2 class="card-title">Product Info</h2>
                <div class="row ml-3">
                  <div class="col-md-12">
                    <p>Add pertinent information for this product</p>
                
                    <div class="row">
                      <div class="col-md-8 border-right">
                        <base-input label="Recipe Name" v-model="product.name" input-classes="form-control"
                          placeholder="Enter recipe name" required />
                          
                        <base-input label="Short Name" v-model="product.short_name"
                          input-classes="form-control" style="margin-bottom: 0px;" placeholder="Enter shortname"
                          required />
                        <small>Limit to {{short_name_length}} characters only</small>
                        
                        <div class="row mt-3">
                          <div class="col-md-6">
                            <base-input label="Stock No." v-model="product.stock_no" required />
                          </div>
                          <div class="col-md-6">
                            <base-input label="Barcode" v-model="product.barcode" />
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <base-input label="Unit" required>
                              <a-select v-model="product.unit_id" showSearch placeholder="Select Unit" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="getUnitCode" :updateKey="updateKey">
                                <a-select-option v-for="option in unitOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                              </a-select>
                            </base-input>
                          </div>

                          <!-- <div v-if="productType == 'P'" class="col-md-6">
                            <base-input type="number" placeholder="Enter Quantity" label="Quantity in Pack" v-model="product.content_quantity" @change="updatePackagePrice" required />
                          </div> -->

                          <div v-if="disable_blank_refcode == true" class="col-md-6">
                            <base-input placeholder="Enter Reference Code" label="Reference Code" v-model="product.reference_code" required />
                          </div>
                          <div v-else class="col-md-6">
                            <base-input v-if="lock_refcode == true" placeholder="Enter Reference Code" label="Reference Code" v-model="product.reference_code" disabled />
                            <base-input v-else placeholder="Enter Reference Code" label="Reference Code" v-model="product.reference_code" />
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <template v-if="formSettings.allow_vat_type_update != true && product.tax_type != null && profileId != 0">
                              <label class="form-control-label">
                                {{product.tax_type == 'V' ? "Vat Type: VAT" : "Vat Type: VAT-EXEMPT"}}
                              </label>
                            </template>
                            <template v-else>
                              <base-input
                                v-if="productType == 'P'"
                                label="VAT Type"
                              >
                                <base-radio name="V" v-model="tax_type" :disabled="btnValue == 1" default>
                                  VAT
                                </base-radio>
                                <base-radio name="N" v-model="tax_type" :disabled="btnValue == 1">
                                  VAT-Exempt
                                </base-radio>
                              </base-input>

                              <base-input v-else label="VAT Type">
                                <base-radio name="V" v-model="tax_type" :disabled="btnValue == 1">
                                  VAT
                                </base-radio>
                                <base-radio name="N" v-model="tax_type" :disabled="btnValue == 1">
                                  VAT-Exempt
                                </base-radio>
                              </base-input>
                            </template>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <h4>Product Image</h4>
                        <div class="clearfix">
                          <a-upload
                          :action="uploadProductImage"
                          listType="picture-card"
                          :fileList="fileList"
                          @preview="handlePreview"
                          @change="handleChange"
                          :headers="authHeadersImage"
                          >
                          <div v-if="fileList.length < 1 && imageLoaded == true"> +
                              <div class="ant-upload-text">Upload</div>
                            </div>
                          </a-upload>
                          <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                            <img alt="example" style="width: 100%" :src="previewImage" />
                          </a-modal>
                        </div>

                        <base-input label="Status" required>
                          <select size="large" class="form-control" v-model="product.status" style="width: 50%">
                            <option v-for="option in statusOptions" v-bind:value="option.key" v-bind:key="option.key">
                              {{ option.value }}
                            </option>
                          </select>
                        </base-input>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <hr>
                        <h6 class="navbar-heading text-muted">RECIPE INGREDIENTS DEFINITION</h6>
                        <base-input  label="Select Ingredients for the recipe" required>
                          <a-input-group compact>
                            <a-select v-model="searchFilter" defaultValue="name" style="width: 25%" size="large">
                              <a-select-option value="name">Search by Name</a-select-option>
                              <a-select-option value="barcode">Search by Barcode</a-select-option>
                              <a-select-option value="stock_no">Search by Stock No.</a-select-option>
                              <a-select-option value="reference_code">Search by Reference Code</a-select-option>
                            </a-select>

                            <autocomplete
                              style="width: 75%; margin-top: 2px;"
                              ref="autocomplete"
                              placeholder="Search Products"
                              :source="productsEndpoint"
                              input-class="form-control"
                              results-property="data"
                              :results-display="formattedDisplay"
                              :request-headers="authHeaders"
                              @selected="getProductForKit">
                            </autocomplete>
                          </a-input-group>
                        </base-input>

                        <a-table :columns="kitColumns" :dataSource="kitData" :pagination="false" :scroll="{ y: 400 }">
                          <template v-for="col in ['decrypted_quantity']"
                            :slot="col" slot-scope="text, record">
                            <div :key="col">
                              <a-input v-if="record.editable" style="margin: -5px 0" :value="text"
                                @change="e => kitHandleChangeTable(e.target.value, record.key, col)" />
                              <template v-else>{{text}}</template>
                            </div>
                          </template>
                          <template slot="operation" slot-scope="text, record">
                            <div class="editable-row-operations">
                              <span v-if="record.editable">
                                <a class="btn btn-success btn-sm" style="color: #fff" @click="() => kitSave(record.key)">Save</a>
                                <a-popconfirm title="Sure to cancel?"
                                  @confirm="() => kitCancel(record.key)">
                                  <a class="btn btn-warning btn-sm" style="color: #fff">Cancel</a>
                                </a-popconfirm>
                              </span>

                              <a-dropdown v-else>
                                <a class="ant-dropdown-link">
                                  <span class="fa fa-ellipsis-v"></span>
                                </a>
                                <a-menu slot="overlay">
                                  <a-menu-item key=1>
                                    <a @click="() => kitEdit(record.key)">Edit</a>
                                  </a-menu-item>
                                  <a-menu-item key=2 v-if="kitData.length">
                                    <a-popconfirm
                                      title="Sure to delete?"
                                      @confirm="() => kitOnDelete(record.key)">
                                      <a href="javascript:;">Delete</a>
                                    </a-popconfirm>
                                  </a-menu-item>
                                </a-menu>
                              </a-dropdown>
                            </div>
                          </template>
                        </a-table>
                        
                        <base-checkbox class="mb-3 mt-3" v-model="recompute_cost">
                          Automatically Recompute Total Kit Cost
                        </base-checkbox>

                        <base-checkbox class="mb-3" v-model="recompute_price">
                          Automatically Recompute Total Kit Price
                        </base-checkbox>
                      </div>
                    </div>
                    <hr>
                    <h6 class="navbar-heading text-muted">RECIPE YIELD DEFINITION</h6>
                    <base-input  label="Select Finished Good of the recipe" required>
                      <a-input-group compact>
                        <a-select v-model="searchFilter" defaultValue="name" style="width: 25%" size="large">
                          <a-select-option value="name">Search by Name</a-select-option>
                          <a-select-option value="barcode">Search by Barcode</a-select-option>
                          <a-select-option value="stock_no">Search by Stock No.</a-select-option>
                          <a-select-option value="reference_code">Search by Reference Code</a-select-option>
                        </a-select>
                        <autocomplete
                          style="width: 75%; margin-top: 2px;"
                          ref="autocomplete"
                          placeholder="Search Products"
                          :source="productsEndpoint"
                          input-class="form-control"
                          results-property="data"
                          :results-display="formattedDisplay"
                          :request-headers="authHeaders"
                          @selected="getProductForYield">
                        </autocomplete>
                      </a-input-group>
                    </base-input>
                    <a-table :columns="yieldColumns" :dataSource="yieldData" :pagination="false" :scroll="{ y: 400 }">
                      <template v-for="col in ['quantity', 'tolerance']"
                        :slot="col" slot-scope="text, record">
                        <div :key="col">
                          <a-input v-if="record.editable" style="margin: -5px 0" :value="text"
                            @change="e => yieldHandleChangeTable(e.target.value, record.key, col)" />
                          <template v-else>{{text}}</template>
                        </div>
                      </template>
                      <template slot="operation" slot-scope="text, record">
                        <div class="editable-row-operations">
                          <span v-if="record.editable">
                            <a class="btn btn-success btn-sm" style="color: #fff" @click="() => yieldSave(record.key)">Save</a>
                            <a-popconfirm title="Sure to cancel?"
                              @confirm="() => yieldCancel(record.key)">
                              <a class="btn btn-warning btn-sm" style="color: #fff">Cancel</a>
                            </a-popconfirm>
                          </span>

                          <a-dropdown v-else>
                            <a class="ant-dropdown-link">
                              <span class="fa fa-ellipsis-v"></span>
                            </a>
                            <a-menu slot="overlay">
                              <a-menu-item key=1>
                                <a @click="() => yieldEdit(record.key)">Edit</a>
                              </a-menu-item>
                              <a-menu-item key=2 v-if="yieldData.length">
                                <a-popconfirm
                                  title="Sure to delete?"
                                  @confirm="() => yieldOnDelete(record.key)">
                                  <a href="javascript:;">Delete</a>
                                </a-popconfirm>
                              </a-menu-item>
                            </a-menu>
                          </a-dropdown>
                        </div>
                      </template>
                    </a-table>


                    <br><hr>
                    <h6 class="navbar-heading text-muted">PRICING & COSTING</h6>
                    <a-tabs defaultActiveKey="1">
                      <a-tab-pane tab="Supplier" key="1">
                        <div class="row">
                          <div class="col-md-12">
                          <p>Set supplier and costing for this product</p>
                          <div class="row">
                            <div v-if="productType == 'P'" class="col-md-8 ml-3">
                              <base-input v-if="disable_blank_supplier == true" label="Primary Supplier" required >
                                <a-select v-model="product.supplier_id" showSearch placeholder="Enter Primary Supplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="updateAlternateSupplier" disabled>
                                  <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                              </base-input>
                              <base-input v-else label="Primary Supplier" >
                                <a-select v-model="product.supplier_id" showSearch placeholder="Enter Primary Supplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="updateAlternateSupplier" disabled>
                                  <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                              </base-input>
                              
                              <base-checkbox class="mb-3" v-model="product.is_alternate_supplier" disabled>
                                Enable alternate supplier
                              </base-checkbox>

                              <div v-if="product.is_alternate_supplier == true">
                                <div class="row">
                                  <div class="col-md-10">
                                  
                                    <base-input label="Add Alternate Supplier">
                                      <a-select v-model="alternate_supplier_id" showSearch placeholder="Enter Supplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" disabled>
                                        <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                      </a-select>
                                    </base-input>
                                  </div>
                                  <div class="col-md-2">
                                    <button v-if="tableErrors.length" type="button" class="btn btn-sm btn-primary" style="margin-top: 30px" disabled>Add</button>
                                    <button v-else type="button" class="btn btn-sm btn-primary" style="margin-top: 30px" @click.prevent="handleAdd" disabled>Add</button>
                                  </div>
                                </div>

                                <a-table :columns="columns" :dataSource="data" :pagination="false" :scroll="{ y: 400 }">
                                  <template v-for="col in ['ordering_cost']"
                                    :slot="col" slot-scope="text, record">
                                    <div :key="col">
                                      <a-input v-if="record.editable"
                                        style="margin: -5px 0" :value="text"
                                        @change="e => handleChangeTable(e.target.value, record.key, col)" />
                                      <template v-else>{{text}}</template>
                                    </div>
                                  </template>
                                </a-table>
                              </div>
                            
                            </div>

                            <div v-else class="col-md-8 ml-3">
                              <base-input v-if="this.disable_blank_supplier == true" label="Primary Supplier" required >
                                <a-select v-model="product.supplier_id" showSearch placeholder="Enter Primary Supplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="updateAlternateSupplier">
                                  <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                              </base-input>
                              <base-input v-else label="Primary Supplier" >
                                <a-select v-model="product.supplier_id" showSearch placeholder="Enter Primary Supplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="updateAlternateSupplier">
                                  <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                              </base-input>

                              <base-checkbox class="mb-3" v-model="product.is_alternate_supplier">
                                Enable alternate supplier
                              </base-checkbox>

                              <div v-if="product.is_alternate_supplier == true">
                                <div class="row">
                                  <div class="col-md-10">
                                  
                                    <base-input label="Add Alternate Supplier">
                                      <a-select v-model="alternate_supplier_id" showSearch placeholder="Enter Supplier" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                        <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                      </a-select>
                                    </base-input>
                                  </div>
                                  <div class="col-md-2">
                                    <button v-if="tableErrors.length" type="button" class="btn btn-sm btn-primary" style="margin-top: 30px">Add</button>
                                    <button v-else type="button" class="btn btn-sm btn-primary" style="margin-top: 30px" @click.prevent="handleAdd">Add</button>
                                  </div>
                                </div>

                                <a-table :columns="columns" :dataSource="data" :pagination="false" :scroll="{ y: 400 }">
                                  <template v-for="col in ['ordering_cost']"
                                    :slot="col" slot-scope="text, record">
                                    <div :key="col">
                                      <a-input v-if="record.editable"
                                        style="margin: -5px 0" :value="text"
                                        @change="e => handleChangeTable(e.target.value, record.key, col)" />
                                      <template v-else>{{text}}</template>
                                    </div>
                                  </template>
                                  <template slot="operation" slot-scope="text, record">
                                    <div class="editable-row-operations">
                                      <span v-if="record.editable">
                                        <a class="btn btn-success btn-sm" style="color: #fff" @click="() => save(record.key)">Save</a>
                                        <a-popconfirm title="Sure to cancel?"
                                          @confirm="() => cancel(record.key)">
                                          <a class="btn btn-warning btn-sm" style="color: #fff">Cancel</a>
                                        </a-popconfirm>
                                      </span>

                                      <a-dropdown v-else>
                                        <a class="ant-dropdown-link">
                                          <span class="fa fa-ellipsis-v"></span>
                                        </a>
                                        <a-menu slot="overlay">
                                          <a-menu-item key=1>
                                            <a @click="() => edit(record.key)">Edit</a>
                                          </a-menu-item>
                                          <a-menu-item key=2 v-if="data.length">
                                            <a-popconfirm
                                              title="Sure to delete?"
                                              @confirm="() => onDelete(record.key)">
                                              <a href="javascript:;">Delete</a>
                                            </a-popconfirm>
                                          </a-menu-item>
                                        </a-menu>
                                      </a-dropdown>
                                    </div>
                                  </template>
                                </a-table>
                              </div>
                            
                            </div>
                          </div>
                        </div>
                        </div>
                      </a-tab-pane>
                      <a-tab-pane tab="Costing" key="2">
                        <div class="row">
                          <div class="col-md-8 ml-3">
                            <!-- <base-input label="Product Costing Module" >
                              <select size="large" class="form-control" v-model="costing_mode">
                                <option v-for="option in costingOptions" v-bind:value="option.key" v-bind:key="option.key">
                                  {{ option.value }}
                                </option>
                              </select>
                            </base-input> -->
                            <div class="row ml-3">
                              <h3>Costing</h3>
                              <div class="col-md-12">
                                <div v-if="costing_mode == '2'" class="row">
                                  <div class="col-md-6">
                                    <base-input type="number" min="0" placeholder="Enter Original Cost" label="Original Cost" v-model="product.original_cost" name="original" @change="changeAmount"/>
                                  </div>
                                </div>
                                
                                <div class="row">
                                  <div class="col-md-6">
                                    <base-input type="number" min="0" placeholder="Enter Ordering Cost" label="Ordering Cost" v-model="product.ordering_cost" name="ordering" @change="changeAmount" required/>
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="col-md-6">
                                    <base-input type="number" min="0" placeholder="Enter Landed Cost" label="Landed Cost" v-model="product.landed_cost" name="landed" @change="changeAmount" required />
                                  </div>
                                  <div v-if="costing_mode == '2'" class="col-md-6">
                                    <base-input type="number" min="0" placeholder="Enter Landed Cost (no VAT)" label="Landed Cost (No VAT)" v-model="product.landed_cost_no_vat" disabled/>
                                  </div>
                                </div>

                                <div v-if="costing_mode == '2'" class="row">
                                  <div class="col-md-6">
                                    <base-input placeholder="Enter Last Discount" label="Last Discount" v-model="product.last_discount_text"/>
                                  </div>
                                </div>

                                <div v-if="costing_mode == '1'" class="row">
                                  <div class="col-md-6">
                                    <base-input type="number" min="0" placeholder="Enter Markup" label="Markup Percentage" v-model="product.markup_percent" name="retail" @change="computePrice" required />
                                  </div>
                                </div>
                              </div>
                              <h3>Pricing</h3>
                              <div class="col-md-12">
                                <div class="row">
                                  <div class="col-md-6">
                                    <base-input type="number" min="0" placeholder="Enter Retail Price" label="Retail Price" v-model="product.retail_price" required />
                                  </div>
                                  <div v-if="costing_mode == '2'" class="col-md-6">
                                    <base-input type="number" min="0" placeholder="Enter Markup " label="Markup" v-model="product.markup_percent" name="retail" @change="computePrice" required />
                                  </div>
                                  <br/>
                                </div>
                                
                                <div class="row">
                                  <div class="col-md-6">
                                    <base-input type="number" min="0" placeholder="Enter Original Price" label="Original Price" v-model="product.original_price" name="original_price" required />
                                  </div>
                                </div>

                                <div v-if="costing_mode == '2'">
                                  <div class="row">
                                    <div class="col-md-6">
                                      <base-input type="number" min="0" v-if="disable_blank_wholesale_price == true" placeholder="Enter Wholesale Price" label="Wholesale Price" v-model="product.wholesale_price" required />

                                      <base-input type="number" min="0" v-else placeholder="Enter Wholesale Price" label="Wholesale Price" v-model="product.wholesale_price"/>
                                    </div>
                                    <div class="col-md-6">
                                      <base-input type="number" min="0" placeholder="Enter Markup" label="Markup" v-model="markup_wholesale_price" name="wholesale" @change="computePrice"/>
                                    </div>
                                  </div>

                                  <div class="row">
                                    <div class="col-md-6">
                                      <base-input type="number" min="0" v-if="disable_blank_least_price == true" placeholder="Enter Least Price" label="Least Price" v-model="product.least_price" required />

                                      <base-input type="number" min="0" v-else placeholder="Enter Least Price" label="Least Price" v-model="product.least_price"/>
                                    </div>
                                    <div class="col-md-6">
                                      <base-input type="number" min="0" placeholder="Enter Markup" label="Markup" v-model="markup_least_price" name="least" @change="computePrice"/>
                                    </div>
                                  </div>

                                  <div class="row">
                                    <div class="col-md-6">
                                      <base-input type="number" min="0" v-if="disable_blank_special_price == true" placeholder="Enter Special Price" label="Special Price" v-model="product.special_price" required />

                                      <base-input type="number" min="0" v-else placeholder="Enter Special Price" label="Special Price" v-model="product.special_price"/>
                                    </div>
                                    <div class="col-md-6">
                                      <base-input type="number" min="0" placeholder="Enter Markup" label="Markup" v-model="markup_special_price" name="special" @change="computePrice"/>
                                    </div>
                                  </div>

                                  <div class="row">
                                    <div class="col-md-6">
                                      <base-input type="number" min="0" v-if="disable_blank_price4 == true" placeholder="Enter Price 4" label="Price 4" v-model="product.price4" required />

                                      <base-input type="number" min="0" v-else placeholder="Enter Price 4" label="Price 4" v-model="product.price4"/>
                                    </div>
                                    <div class="col-md-6">
                                      <base-input type="number" min="0" placeholder="Enter Markup" label="Markup" v-model="markup_price4" name="price4" @change="computePrice"/>
                                    </div>
                                  </div>

                                  <div class="row">
                                    <div class="col-md-6">
                                      <base-input type="number" min="0" v-if="disable_blank_price5 == true" placeholder="Enter Price 5" label="Price 5" v-model="product.price5" required />
                                      <base-input type="number" min="0" v-else placeholder="Enter Price 5" label="Price 5" v-model="product.price5"/>
                                    </div>
                                    <div class="col-md-6">
                                      <base-input type="number" min="0" placeholder="Enter Markup" label="Markup" v-model="markup_price5" name="price5" @change="computePrice"/>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a-tab-pane>
                    </a-tabs>

                    <matrix-form v-if="productType == 'M'" :formSettings="formSettings" @setMatrixData="setMatrixData" :key="componentKey" :product="product"></matrix-form>
                  </div>
                </div>
              </div>

              <div v-if="activeKey == '1' && basicKey == '2'" class="card-body">
                <h2 class="card-title">Product Classification</h2>
                <div class="row ml-3">
                  <div v-if="productType == 'P'" class="col-md-8">
                    <p>Set categorization for this product</p>
                    <h3>Assign Product Category</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <base-input label="Category">
                          <a-cascader :options="categoryOptions" :showSearch="{filter}" v-model="cascader_category"
                            placeholder="Please select category" style="width: 100%" @change="updateParams" disabled/>
                        </base-input>
                      </div>
                    </div>

                    <h3>Assign Brand</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <a-select v-model="product.brand_id" showSearch placeholder="Select Brand" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="handleSearch" disabled>
                          <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                          <a-select-option v-for="option in brandOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                        </a-select>
                      </div>
                    </div>

                    <h3>Assign Tags</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <base-input label="Tags">
                          <a-select v-model="product_properties.property_id" showSearch mode="multiple" placeholder="Select Tags" 
                            optionFilterProp="children" style="width: 100%" :filterOption="filterOption" disabled>
                            <a-select-option v-for="option in propertyOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                          </a-select>
                        </base-input>
                      </div>
                    </div>

                    <h3>Assign Product Line</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <base-input label="Product Line"> 
                          <a-select v-model="product.product_line_id" showSearch placeholder="Select Product Line" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="getIntroDate" :key="updateKey" disabled>
                            <a-select-option v-for="option in productLineOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                          </a-select>
                        </base-input>

                        <base-input v-if="product.product_line_id > 0" label="Intro Date">
                          <br><a-date-picker v-model="product.intro_date" :format="dateFormat" style="width: 100%" @change="updateIntroDate" :key="updateKey" disabled/>
                        </base-input>
                      </div>
                    </div>

                    <div class="d-flex justify-content-center mt-4">
                      <button type="button" class="btn btn-sm btn-outline-secondary" @click='showAdvancedInfoDiv' > 
                        More Classifications {{showAdvancedInfo? '↟' : '↡'}} 
                      </button>
                    </div>

                    <div v-if='showAdvancedInfo' class="row mt-2 ml-3"> 
                      <h3>Assign Color</h3>
                      <div class="col-md-12">
                        <base-input label="Color">
                          <a-select v-model="product.color_id" showSearch placeholder="Select Color" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" disabled>
                            <a-select-option v-for="option in colorOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                          </a-select>
                        </base-input>
                      </div>
                    </div>  
                  </div>

                  <div v-else class="col-md-8">
                    <p>Set categorization for this product</p>
                    <h3>Assign Product Category</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <base-input v-if="disable_blank_department == true || disable_blank_division == true || disable_blank_section == true || disable_blank_category == true" label="Category" required >
                          <a-cascader :options="categoryOptions" :showSearch="{filter}" v-model="cascader_category"
                            placeholder="Please select category" style="width: 100%" @change="updateParams" />
                        </base-input>
                        <base-input v-else label="Category">
                          <a-cascader :options="categoryOptions" :showSearch="{filter}" v-model="cascader_category"
                            placeholder="Please select category" style="width: 100%" @change="updateParams" />
                        </base-input>
                      </div>
                    </div>

                    <h3>Assign Brand</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <base-input v-if="disable_blank_brand == true" label="Brand" required >
                          <a-select v-model="product.brand_id" showSearch placeholder="Select Brand" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="handleSearch" required>
                            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                            <a-select-option v-for="option in brandOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                          </a-select>
                        </base-input>
                        <base-input v-else label="Brand">
                          <a-select v-model="product.brand_id" showSearch placeholder="Select Brand" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="handleSearch">
                            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                            <a-select-option v-for="option in brandOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                          </a-select>
                        </base-input>
                      </div>
                    </div>

                    <h3>Assign Tags</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <base-input label="Tags">
                          <a-select v-model="product_properties.property_id" showSearch mode="multiple" placeholder="Select Tags" 
                            optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                            <a-select-option v-for="option in propertyOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                          </a-select>
                        </base-input>
                      </div>
                    </div>

                    <h3>Assign Product Line</h3>
                    <div class="row ml-3">
                      <div class="col-md-12">
                        <base-input v-if="disable_blank_product_line == true" label="Product Line" required>
                          <a-select v-model="product.product_line_id" showSearch placeholder="Select Product Line" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="getIntroDate" :key="updateKey">
                            <a-select-option v-for="option in productLineOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                          </a-select>
                        </base-input>
                        <base-input v-else label="Product Line">
                          <a-select v-model="product.product_line_id" showSearch placeholder="Select Product Line" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="getIntroDate" :key="updateKey">
                            <a-select-option v-for="option in productLineOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                          </a-select>
                        </base-input>

                        <base-input v-if="product.product_line_id > 0" label="Intro Date">
                          <br><a-date-picker v-model="product.intro_date" :format="dateFormat" style="width: 100%" @change="updateIntroDate" :key="updateKey"/>
                        </base-input>
                      </div>
                    </div>

                    <div class="d-flex justify-content-center mt-4" v-if="productType != 'M'">
                      <button type="button" class="btn btn-sm btn-outline-secondary" @click='showAdvancedInfoDiv' > 
                        More Classifications {{showAdvancedInfo? '↟' : '↡'}} 
                      </button>
                    </div>

                    <div v-if='showAdvancedInfo' class="row mt-2 ml-3"> 
                      <h3>Assign Color</h3>
                      <div class="col-md-12">
                        <base-input label="Color">
                          <a-select v-model="product.color_id" showSearch placeholder="Select Color" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                            <a-select-option v-for="option in colorOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                          </a-select>
                        </base-input>
                      </div>
                    </div>  
                  </div>
                </div>
              </div>

              <div v-if="activeKey == '1' && basicKey == '3'" class="card-body">
                <h2 class="card-title">Additional Information</h2>
                <div class="row ml-3">
                  <div v-if="productType == 'P'" class="col-md-8">
                    <base-input placeholder="Enter Remark" label="Remark" v-model="product.remark" disabled />

                    <base-checkbox class="mb-3" v-model="product.is_require_lotcode" disabled>
                      This product requires Lot Codes
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="product.is_require_remark" disabled>
                      This product requires Item Remarks
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="allow_zero" disabled>
                      This product allows zero prices
                    </base-checkbox>
                  </div>
                  <div v-else class="col-md-8">
                    <base-input placeholder="Enter Remark" label="Remark" v-model="product.remark" />

                    <base-checkbox class="mb-3" v-model="product.is_require_lotcode">
                      This product requires Lot Codes
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="product.is_require_remark">
                      This product requires Item Remarks
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="allow_zero">
                      This product allows zero prices
                    </base-checkbox>
                  </div>
                </div>

                <h2 class="card-title">Integrations</h2>
                <div class="row ml-3">
                  <div v-if="productType == 'P'" class="col-md-8">
                    <p>Set reference date for integration</p>
                    <div class="row">
                      <div class="col-md-6">
                        <base-input label="Reference Date">
                          <br><a-date-picker v-model="product.reference_date" :format="dateFormat" style="width: 100%" @change="updateRefDate" :key="updateKey" disabled/>
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <div v-else class="col-md-8">
                    <p>Set reference date for integration</p>
                    <div class="row">
                      <div class="col-md-6">
                        <base-input label="Reference Date">
                          <br><a-date-picker v-model="product.reference_date" :format="dateFormat" style="width: 100%" @change="updateRefDate" :key="updateKey"/>
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="activeKey == '2' && advanceKey == '1' && (productType == '' || productType == 'K' || productType == 'N')" class="card-body">
                <h2 class="card-title">Alternate Barcode</h2>
                <div class="row ml-3">
                  <div class="col-md-8">
                    <p>Add alternate barcode for your product</p>
                    <h3>Alternate Barcode</h3>
                    <button v-if="tableErrors.length" type="button" class="btn btn-sm btn-primary float-right" style="margin-bottom: 10px">Add</button>
                    <button v-else type="button" class="btn btn-sm btn-primary float-right" style="margin-bottom: 10px" @click.prevent="barcodeHandleAdd">Add</button>
                    <br><br>
                    <a-table :columns="barcodeColumns" :dataSource="barcodeData" :pagination="false" :scroll="{ y: 400 }">
                      <template v-for="col in ['barcode', 'status']"
                        :slot="col" slot-scope="text, record">
                        <div :key="col">
                          <div v-if="col == 'status'">
                            <div v-if="record.status == 'A'">
                              <a-switch v-if="record.editable" defaultChecked @change="e => barcodeHandleChangeTable(e, record.key, col)"/>
                              <a-switch v-else defaultChecked :disabled="true"/>
                            </div>

                            <div v-else>
                              <a-switch v-if="record.editable" @change="e => barcodeHandleChangeTable(e, record.key, col)"/>
                              <a-switch v-else :disabled="true"/>
                            </div>
                          </div>
                          <div v-else>
                            <a-input v-if="record.editable" style="margin: -5px 0" :value="text"
                              @change="e => barcodeHandleChangeTable(e.target.value, record.key, col)" />
                            <template v-else>{{text}}</template>
                          </div>
                        </div>
                      </template>
                      <template slot="operation" slot-scope="text, record">
                        <div class="editable-row-operations">
                          <span v-if="record.editable">
                            <a class="btn btn-success btn-sm" style="color: #fff" @click="() => barcodeSave(record.key)">Save</a>
                            <a-popconfirm title="Sure to cancel?"
                              @confirm="() => barcodeCancel(record.key)">
                              <a class="btn btn-warning btn-sm" style="color: #fff">Cancel</a>
                            </a-popconfirm>
                          </span>

                          <a-dropdown v-else>
                            <a class="ant-dropdown-link">
                              <span class="fa fa-ellipsis-v"></span>
                            </a>
                            <a-menu slot="overlay">
                              <a-menu-item key=1>
                                <a @click="() => barcodeEdit(record.key)">Edit</a>
                              </a-menu-item>
                              <a-menu-item key=2 v-if="barcodeData.length">
                                <a-popconfirm
                                  title="Sure to delete?"
                                  @confirm="() => barcodeOnDelete(record.key)">
                                  <a href="javascript:;">Delete</a>
                                </a-popconfirm>
                              </a-menu-item>
                            </a-menu>
                          </a-dropdown>
                        </div>
                      </template>
                    </a-table>
                  </div>
                </div>
              </div>

              <!-- Product Series Form -->          
              <div v-if="activeKey == '2' && advanceKey == '2'" class="card-body">
                <h2 class="card-title">Product Series</h2>
                <div class="row ml-3">
                  <div class="col-md-8">
                    <p>Tracking of the introduction date of item, as well as the repeat orders</p>
                    
                    <base-input label="Intro Date">
                      <a-date-picker name="intro_date" class="intro_date_field" :format="dateFormat" v-model="product_series.intro_date" @change="updateProductSeriesIntroDate" required />
                    </base-input>

                    <div class="row">
                        <div class="col">
                          <base-input type="text" label="Series Name" name="series_name" class="series_name_field" v-model="product_series.series_name" placeholder="Enter Series Name" required />
                        </div>
                        <div class="col">
                          <base-input label="Series Date">
                            <a-date-picker name="series_date" class="series_date_field" :format="dateFormat" v-model="product_series.series_date" placeholder="Select date" @change="updateProductSeriesSeriesDate" required/>
                          </base-input>
                        </div>
                    </div>
                    <div class="float-right">
                      <template v-if="productseriesButton === 'add'">
                        <button type="button" class="btn btn-sm btn-primary float-right" name="submit" @click="productseriesHandleAdd" >
                          Add
                        </button>
                      </template>

                      <template v-else-if="productseriesButton === 'delete'">
                        <a-popconfirm 
                          title="Delete Product Series?"
                          @confirm="() => productseriesDelete(productseriesKey)">
                          <a href="javascript:;" class="btn btn-warning btn-sm" style="color: #fff">Delete</a>
                        </a-popconfirm>
                      </template>

                    </div>

                    <br/>
                    <br/>
                  </div>

                  <!-- product series table -->
                  <div class="col-md-8">
                    <a-table :columns="productseriesColumns" :dataSource="productseriesData" :pagination="false" :scroll="{ y: 400 }" :customRow="changeProductSeriesButton" >

                    </a-table>

                  </div>
                  <!-- end product series table -->
                  
                </div>
              </div>
              <!-- End of Product Series Form -->
              <div v-if="activeKey == '2' && advanceKey == '3'" class="card-body">
                <h2 class="card-title">Site Price</h2>
                <div class="row ml-3">
                  <div class="col-md-8">
                    <p>Set different prices for this product on different sites</p>
                    <base-checkbox class="mb-3" v-model="is_site_price">
                      Enable Site Pricing
                    </base-checkbox>
                    <div v-if="is_site_price">
                      <h3>Site Prices</h3>
                      <button v-if="tableErrors.length" type="button" class="btn btn-sm btn-primary float-right" style="margin-bottom: 10px">Add</button>
                      <button v-else type="button" class="btn btn-sm btn-primary float-right" style="margin-bottom: 10px" @click.prevent="showDrawer(-1)">Add</button>
                      <br><br>
                      <a-table :columns="priceColumns" :dataSource="priceData" :pagination="false" :scroll="{ y: 400 }">
                        <template slot="operation" slot-scope="text, record">
                          <div class="editable-row-operations">
                            <a-dropdown>
                              <a class="ant-dropdown-link">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item key=1>
                                  <a @click="() => showDrawer(record.key)">Edit</a>
                                </a-menu-item>
                                <a-menu-item key=2 v-if="priceData.length">
                                  <a-popconfirm
                                    title="Sure to delete?"
                                    @confirm="() => priceOnDelete(record.key)">
                                    <a href="javascript:;">Delete</a>
                                  </a-popconfirm>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown>
                          </div>
                        </template>
                      </a-table>

                      <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="visible">
                        <div>
                          <site-price-form :targetKey="targetKey" :product="product" :targetData="priceData" @closeDrawer="closeDrawer" @setTargetData="setTargetData" @updateTargetData="updateTargetData" :key="componentKey" :formSettings="formSettings" ></site-price-form>
                        </div>
                      </a-drawer>
                    </div>
                    
                  </div>
                </div>
              </div>

              <div v-if="activeKey == '2' && advanceKey == '4'" class="card-body">
                <h2 class="card-title">Site Product</h2>
                
                <div class="row ml-3">
                  <div class="col-md-8">
                    <p>Set which sites this product is available for selling</p>
                    <h5>Atleast one site should be selected (all sites selected by default)</h5>
                    <a-table :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
                      :columns="productColumns"
                      :dataSource="productData" :pagination="false" :scroll="{ y: 400 }"
                      />
                  </div>
                </div>
              </div>

              <div v-if="activeKey == '2' && advanceKey == '5'" class="card-body">
                <h2 class="card-title">Re-order Control</h2>
                <div class="row ml-3">
                  <div class="col-md-8">
                    <p>Ensure that optimum stock quantity for this product is met by setting up alerts</p>
                    <base-checkbox class="mb-3" v-model="product.is_notification">
                      Send a notification when stock for this item has reached minimum/maximum quantity
                    </base-checkbox>

                    <div class="row">
                      <div class="col-md-6">
                        <base-input type="number" min="0" placeholder="Enter Quantity" label="Minimum Quantity" v-model="product.min_quantity"/>
                      </div>

                      <div class="col-md-6">
                        <base-input type="number" min="0" placeholder="Enter Quantity" label="Maximum Quantity" v-model="product.max_quantity"/>
                      </div>
                    </div>

                    <base-input label="Turn on this function" >
                      <select size="large" class="form-control" v-model="reorder_mode">
                        <option v-for="option in reorderOptions" v-bind:value="option.key" v-bind:key="option.key">
                          {{ option.value }}
                        </option>
                      </select>
                    </base-input>

                    <div v-if="reorder_mode == '2'"  class="row ml-3">
                      <div class="col-md-12">
                        <base-input label="Select Site">
                          <a-select v-model="site_products.site_id" showSearch placeholder="Enter Site" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                          </a-select>
                        </base-input>

                        <button v-if="tableErrors.length" type="button" class="btn btn-sm btn-primary float-right" style="margin-bottom: 10px">Add</button>
                        <button v-else type="button" class="btn btn-sm btn-primary float-right" style="margin-bottom: 10px" @click.prevent="reorderHandleAdd">Add</button>
                        <br><br>
                        <a-table :columns="reorderColumns" :dataSource="reorderData" :pagination="false" :scroll="{ y: 400 }">
                          <template v-for="col in ['min_quantity', 'max_quantity']"
                            :slot="col" slot-scope="text, record">
                            <div :key="col">
                              <a-input type="number" min="0" v-if="record.editable"
                                style="margin: -5px 0" :value="text"
                                @change="e => reorderHandleChangeTable(e.target.value, record.key, col)" />
                              <template v-else>{{text}}</template>
                            </div>
                          </template>
                          <template slot="operation" slot-scope="text, record">
                            <div class="editable-row-operations">
                              <span v-if="record.editable">
                                <a class="btn btn-success btn-sm" style="color: #fff" @click="() => reorderSave(record.key)">Save</a>
                                <a-popconfirm title="Sure to cancel?"
                                  @confirm="() => reorderCancel(record.key)">
                                  <a class="btn btn-warning btn-sm" style="color: #fff">Cancel</a>
                                </a-popconfirm>
                              </span>

                              <a-dropdown v-else>
                                <a class="ant-dropdown-link">
                                  <span class="fa fa-ellipsis-v"></span>
                                </a>
                                <a-menu slot="overlay">
                                  <a-menu-item key=1>
                                    <a @click="() => reorderEdit(record.key)">Edit</a>
                                  </a-menu-item>
                                  <a-menu-item key=2 v-if="reorderData.length">
                                    <a-popconfirm
                                      title="Sure to delete?"
                                      @confirm="() => reorderOnDelete(record.key)">
                                      <a href="javascript:;">Delete</a>
                                    </a-popconfirm>
                                  </a-menu-item>
                                </a-menu>
                              </a-dropdown>
                            </div>
                          </template>
                        </a-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="activeKey == '2' && advanceKey == '6'" class="card-body">
                <h2 class="card-title">Selling</h2>
                <div class="row ml-3">
                  <div v-if="productType == 'P'" class="col-md-8">
                    <p>Set properties for this item at point of sale</p>
                    <h4>Mark item as</h4>
                    <base-checkbox class="mb-3" v-model="product.is_concession" disabled>
                      Concession Item
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="product.is_weighted" disabled>
                      Weighted Item
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="product.is_grocery" disabled>
                      Grocery Item
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="product.is_open_department" disabled>
                      Open Department Item
                    </base-checkbox>
                  </div>

                  <div v-else class="col-md-8">
                    <p>Set properties for this item at point of sale</p>
                    <h4>Mark item as</h4>
                    <base-checkbox class="mb-3" v-model="product.is_concession">
                      Concession Item
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="product.is_weighted">
                      Weighted Item
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="product.is_grocery">
                      Grocery Item
                    </base-checkbox>

                    <base-checkbox class="mb-3" v-model="product.is_open_department">
                      Open Department Item
                    </base-checkbox>
                  </div>
                </div>
              </div>

              <div v-if="activeKey == '2' && advanceKey == '7'" class="card-body">
                <h2 class="card-title">SC/PWD</h2>
                <div class="row ml-3">
                  <div v-if="productType == 'P'" class="col-md-8">
                    <p>Set how this item handles SC/PWD Discounts</p>
                    <h4>Senior Citizen Discounting</h4>
                    <base-input label="SC Discount" disabled>
                      <a-input type="number" min="0" v-model="product.sc_discount_percent" addonAfter="%" disabled/>
                    </base-input>

                    <base-checkbox class="mb-3" v-model="product.is_senior_vatex" disabled>
                      SC VAT-Exempt
                    </base-checkbox>
                      
                    <base-checkbox class="mb-3" v-model="product.is_senior_nolimit" disabled>
                      Disable SC Limit for this item
                    </base-checkbox>
                    
                    <base-input label="PWD Discount" disabled>
                      <a-input type="number" min="0" v-model="product.pwd_discount_percent" addonAfter="%" disabled/>
                    </base-input>

                    <base-checkbox class="mb-3" v-model="product.is_pwd_vatex" disabled>
                      PWD VAT-Exempt
                    </base-checkbox>
                    
                    <base-checkbox class="mb-3" v-model="product.is_pwd_nolimit" disabled>
                      Disable PWD Limit for this item
                    </base-checkbox>
                    
                  </div>

                  <div v-else class="col-md-8">
                    <p>Set how this item handles SC/PWD Discounts</p>
                    <h4>Senior Citizen Discounting</h4>
                    <base-input label="SC Discount" disabled>
                      <a-input type="number" min="0" v-model="product.sc_discount_percent" addonAfter="%" @change="onSetVatex" name="sc_discount"/>
                    </base-input>

                    <base-checkbox class="mb-3" v-model="product.is_senior_vatex" disabled>
                      SC VAT-Exempt
                    </base-checkbox>
                      
                    <base-checkbox class="mb-3" v-model="product.is_senior_nolimit" disabled>
                      Disable SC Limit for this item
                    </base-checkbox>
                    
                    <base-input label="PWD Discount" disabled>
                      <a-input type="number" min="0" v-model="product.pwd_discount_percent" addonAfter="%"  @change="onSetVatex" name="pwd_discount"/>
                    </base-input>

                    <base-checkbox class="mb-3" v-model="product.is_pwd_vatex" disabled>
                      PWD VAT-Exempt
                    </base-checkbox>
                    
                    <base-checkbox class="mb-3" v-model="product.is_pwd_nolimit" disabled>
                      Disable PWD Limit for this item
                    </base-checkbox>
                    
                  </div>
                </div>
              </div>

              <div v-if="activeKey == '2' && advanceKey == '8'" class="card-body">
                <h2 class="card-title">CLP</h2>
                <div v-if="productType == 'P'" class="row ml-3">
                  <div class="col-md-8">
                    <p>Apply CLP configuration to this item</p>
                    <base-checkbox class="mb-3" v-model="product.is_reward_item" disabled>
                      Use this item as a reward
                    </base-checkbox>
                    
                    <base-input class="ml-3" v-if="product.is_reward_item == true" placeholder="Enter Points" label="Reward Required Points" v-model="product.reward_required_points" disabled/>

                    <base-checkbox class="mb-3" v-model="product.is_no_clp_points" disabled>
                      This product will not earn points
                    </base-checkbox>
                  </div>
                </div>
                <div v-else class="row ml-3">
                  <div class="col-md-8">
                    <p>Apply CLP configuration to this item</p>
                    <base-checkbox class="mb-3" v-model="product.is_reward_item">
                      Use this item as a reward
                    </base-checkbox>
                    
                    <base-input type="number" min="0" class="ml-3" v-if="product.is_reward_item == true" placeholder="Enter Points" label="Reward Required Points" v-model="product.reward_required_points"/>

                    <base-checkbox class="mb-3" v-model="product.is_no_clp_points">
                      This product will not earn points
                    </base-checkbox>
                  </div>
                </div>
              </div>

              <div v-if="activeKey == '2' && advanceKey == '9'" class="card-body">
                <h2 class="card-title">Commission</h2>
                <div class="row ml-3">
                  <div v-if="productType == 'P'" class="col-md-8">
                    <p>Set commission earned from this product</p>
                    <base-checkbox class="mb-3" v-model="is_enable_sales_commission" disabled>
                      Enable Salesman Commission
                    </base-checkbox>

                    <base-input class="ml-3" v-if="is_enable_sales_commission == true" label="Salesman Commission" >
                      <a-input type="number" min="0" step="any" v-model="product.salesman_commission" addonAfter="%" disabled />
                    </base-input>

                    <base-checkbox class="mb-3" v-model="is_enable_supplier_commission" disabled>
                      Enable Supplier Commission
                    </base-checkbox>

                    <base-input class="ml-3" v-if="is_enable_supplier_commission == true" label="Supplier Commission" >
                      <a-input type="number" min="0" v-model="product.supplier_commission" addonAfter="%" disabled />
                    </base-input>
                  </div>
                   <div v-else class="col-md-8">
                    <p>Set commission earned from this product</p>
                    <base-checkbox class="mb-3" v-model="is_enable_sales_commission">
                      Enable Salesman Commission
                    </base-checkbox>

                    <base-input class="ml-3" v-if="is_enable_sales_commission == true" label="Salesman Commission" >
                      <a-input type="number" min="0" step="any" v-model="product.salesman_commission" addonAfter="%" />
                    </base-input>

                    <base-checkbox class="mb-3" v-model="is_enable_supplier_commission">
                      Enable Supplier Commission
                    </base-checkbox>

                    <base-input class="ml-3" v-if="is_enable_supplier_commission == true" label="Supplier Commission" >
                      <a-input type="number" min="0" v-model="product.supplier_commission" addonAfter="%" />
                    </base-input>
                  </div>
                </div>
              </div>

              <div v-if="activeKey == '2' && advanceKey == '10'" class="card-body">
                <h2 class="card-title">Shelf Code</h2>
                <div class="row ml-3">
                  <div class="col-md-8">
                    <p>Add a shelf code to this product</p>
                    <base-input placeholder="Enter Shelf Code" label="Shelf Code" v-model="product.shelf_code"/>

                    <base-input label="Add a shelf code" >
                      <select size="large" class="form-control" v-model="shelf_code_mode">
                        <option v-for="option in shelfCodeOptions" v-bind:value="option.key" v-bind:key="option.key">
                          {{ option.value }}
                        </option>
                      </select>
                    </base-input>
                    
                    <div v-if="shelf_code_mode == '2'">
                      <base-input label="Select Site">
                        <a-select v-model="site_products.site_id" showSearch placeholder="Enter Site" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                          <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                        </a-select>
                      </base-input>

                      <button v-if="tableErrors.length" type="button" class="btn btn-sm btn-primary float-right" style="margin-bottom: 10px">Add</button>
                      <button v-else type="button" class="btn btn-sm btn-primary float-right" style="margin-bottom: 10px" @click.prevent="shelfHandleAdd">Add</button>
                      <br><br>
                      <a-table :columns="shelfColumns" :dataSource="shelfData" :pagination="false" :scroll="{ y: 400 }">
                        <template v-for="col in ['shelf_code']"
                          :slot="col" slot-scope="text, record">
                          <div :key="col">
                            <a-input v-if="record.editable" style="margin: -5px 0" :value="text"
                              @change="e => shelfHandleChangeTable(e.target.value, record.key, col)" />
                            <template v-else>{{text}}</template>
                          </div>
                        </template>
                        <template slot="operation" slot-scope="text, record">
                          <div class="editable-row-operations">
                            <span v-if="record.editable">
                              <a class="btn btn-success btn-sm" style="color: #fff" @click="() => shelfSave(record.key)">Save</a>
                              <a-popconfirm title="Sure to cancel?"
                                @confirm="() => shelfCancel(record.key)">
                                <a class="btn btn-warning btn-sm" style="color: #fff">Cancel</a>
                              </a-popconfirm>
                            </span>

                            <a-dropdown v-else>
                              <a class="ant-dropdown-link">
                                <span class="fa fa-ellipsis-v"></span>
                              </a>
                              <a-menu slot="overlay">
                                <a-menu-item key=1>
                                  <a @click="() => shelfEdit(record.key)">Edit</a>
                                </a-menu-item>
                                <a-menu-item key=2 v-if="shelfData.length">
                                  <a-popconfirm
                                    title="Sure to delete?"
                                    @confirm="() => shelfOnDelete(record.key)">
                                    <a href="javascript:;">Delete</a>
                                  </a-popconfirm>
                                </a-menu-item>
                              </a-menu>
                            </a-dropdown>
                          </div>
                        </template>
                      </a-table>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="activeKey == '2' && advanceKey == '11'" class="card-body">
                <h2 class="card-title">Dimension</h2>
                <div class="row ml-3">
                  <div class="col-md-8">
                    <p>Add product dimension for computation of warehouse capacity</p>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group has-label">
                          <label class="form-control-label">Length</label>
                          <a-input v-model='product.length' min="0" type='number' input-classes="form-control" @change="limit" name="length"/>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group has-label">
                          <label class="form-control-label">Width</label>
                          <a-input v-model='product.width' min="0" type='number' input-classes="form-control" @change="limit" name="width"/>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group has-label">
                          <label class="form-control-label">Height</label>
                          <a-input v-model='product.height' min="0" type='number' input-classes="form-control" @change="limit" name="height"/>
                        </div>
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group has-label">
                          <label class="form-control-label">Volume</label>
                          <a-input v-model='product.volume' min="0" type='number' input-classes="form-control" @change="limit" name="volume"/>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group has-label">
                          <label class="form-control-label">Weight</label>
                          <a-input v-model='product.weight' min="0" type='number' input-classes="form-control" @change="limit" name="weight"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <br><br><br>
              <div v-if="serverType == 'ho'" class="w-100 row d-flex justify-content-between px-2" style="position: absolute;bottom: 20px;right: 15px;width: -webkit-fill-available;padding: 10px;">
                <div>
                    <button type="button" class="btn btn-primary" @click="handleBackButton" v-if="hideBackBtn">Back</button>
                    <button type="button" class="btn btn-primary" @click="handleNextButton" v-if="hideNextBtn" >Next</button>
                </div>
                <div>
                  <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="showModal('create')">Create</button> 
                  <button v-else type="button" class="btn btn-primary float-right" @click.prevent="showModal('update')">Update</button> 
                </div>  
              </div>
              <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;padding: 10px;">
                <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
              </div>

              <a-modal title="Warning" v-model="modalVisible" @ok="handleOk">
                <p>You have the following warning(s):</p>
                <ul>
                  <li v-for="warning in warnings" v-bind:key="warning">{{ warning }}</li>
                </ul>
              </a-modal>
            </form>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
  import HTTPRequest from '../../controllers/httpRequest.js'
  import secureStorage from '../../controllers/secureStorage.js'
  import ValidateField from '../../components/validateFormUtils.js'
  import SitePriceForm from '../../views/Products/SitePriceForm'
  import MatrixForm from '../../views/Products/MatrixForm'
  import { mapState } from 'vuex'
  import moment from 'moment';
  import Autocomplete from 'vuejs-auto-complete'

  const columns = [{
      title: 'SUPPLIER',
      dataIndex: 'supplier_name',
      width: '25%',
      scopedSlots: {
        customRender: 'supplier_name'
      },
    },
    {
      title: 'CODE',
      dataIndex: 'supplier_code',
      width: '15%',
      scopedSlots: {
        customRender: 'supplier_code'
      },
    },
    {
      title: 'ORDERING COST',
      dataIndex: 'ordering_cost',
      width: '40%',
      scopedSlots: {
        customRender: 'ordering_cost'
      },
    },
    {
      title: '',
      dataIndex: 'operation',
      scopedSlots: {
        customRender: 'operation'
      },
    }
  ];

  const barcodeColumns = [{
      title: 'NAME',
      dataIndex: 'name',
      width: '25%',
      scopedSlots: {
        customRender: 'name'
      },
    },
    {
      title: 'BARCODE',
      dataIndex: 'barcode',
      width: '25%',
      scopedSlots: {
        customRender: 'barcode'
      },
    },
    {
      title: 'ACTIVE',
      dataIndex: 'status',
      width: '25%',
      scopedSlots: {
        customRender: 'status'
      },
    },
    {
      title: '',
      dataIndex: 'operation',
      scopedSlots: {
        customRender: 'operation'
      },
    }
  ];

  const shelfColumns = [{
      title: 'SITE',
      dataIndex: 'site_name',
      width: '25%',
      scopedSlots: {
        customRender: 'site_name'
      },
    },
    {
      title: 'SHELF CODE',
      dataIndex: 'shelf_code',
      width: '40%',
      scopedSlots: {
        customRender: 'shelf_code'
      },
    },
    {
      title: '',
      dataIndex: 'operation',
      scopedSlots: {
        customRender: 'operation'
      },
    }
  ];

  const reorderColumns = [{
      title: 'SITE',
      dataIndex: 'site_name',
      width: '25%',
      scopedSlots: {
        customRender: 'site_name'
      },
    },
    {
      title: 'MINIMUM QUANTITY',
      dataIndex: 'min_quantity',
      width: '25%',
      scopedSlots: {
        customRender: 'min_quantity'
      },
    },
    {
      title: 'MAXIMUM QUANTITY',
      dataIndex: 'max_quantity',
      width: '25%',
      scopedSlots: {
        customRender: 'max_quantity'
      },
    },
    {
      title: '',
      dataIndex: 'operation',
      scopedSlots: {
        customRender: 'operation'
      },
    }
  ];

  const priceColumns = [{
      title: 'SITE',
      dataIndex: 'site_name',
      width: '20%',
      scopedSlots: {
        customRender: 'site_name'
      },
    },
    {
      title: 'RETAIL PRICE',
      dataIndex: 'retail_price',
      width: '15%',
      scopedSlots: {
        customRender: 'retail_price'
      },
    },
    {
      title: 'WHOLESALE PRICE',
      dataIndex: 'wholesale_price',
      width: '20%',
      scopedSlots: {
        customRender: 'wholesale_price'
      },
    },
    {
      title: 'LEAST PRICE',
      dataIndex: 'least_price',
      width: '15%',
      scopedSlots: {
        customRender: 'least_price'
      },
    },
    {
      title: 'SPECIAL PRICE',
      dataIndex: 'special_price',
      width: '20%',
      scopedSlots: {
        customRender: 'special_price'
      },
    },
    {
      title: '',
      dataIndex: 'operation',
      scopedSlots: {
        customRender: 'operation'
      },
    }
  ];

  const kitColumns = [
    {
      title: 'NAME',
      dataIndex: 'short_name',
      width: '20%',
      scopedSlots: {
        customRender: 'short_name' 
      },
    },
    {
      title: 'BARCODE',
      dataIndex: 'barcode',
      width: '20%',
      scopedSlots: {
        customRender: 'barcode' 
      },
    },
    {
      title: 'QTY',
      dataIndex: 'decrypted_quantity',
      width: '10%',
      scopedSlots: {
        customRender: 'decrypted_quantity'
      },
    },
    // {
    //   title: 'UNIT',
    //   dataIndex: 'unit_code',
    //   width: '10%',
    //   scopedSlots: {
    //     customRender: 'unit_code'
    //   },
    // },
    // {
    //   title: 'COST',
    //   dataIndex: 'cost',
    //   width: '10%',
    //   scopedSlots: {
    //     customRender: 'cost'
    //   },
    // },
    // {
    //   title: 'PRICE',
    //   dataIndex: 'retail_price',
    //   width: '10%',
    //   scopedSlots: {
    //     customRender: 'retail_price'
    //   },
    // },
    {
      title: '',
      dataIndex: 'operation',
      scopedSlots: {
        customRender: 'operation'
      },
    }
  ];

  const yieldColumns = [{
      title: 'QTY',
      dataIndex: 'quantity',
      width: '10%',
      scopedSlots: {
        customRender: 'quantity'
      },
    },
    {
      title: 'TOLERANCE',
      dataIndex: 'tolerance',
      width: '15%',
      scopedSlots: {
        customRender: 'tolerance'
      },
    },
    {
      title: 'BARCODE',
      dataIndex: 'barcode',
      width: '20%',
      scopedSlots: {
        customRender: 'barcode' 
      },
    },
    {
      title: 'NAME',
      dataIndex: 'name',
      width: '20%',
      scopedSlots: {
        customRender: 'name'
      },
    },
    {
      title: '',
      dataIndex: 'operation',
      scopedSlots: {
        customRender: 'operation'
      },
    }
  ];

  const productColumns = [{
      title: 'SITE',
      dataIndex: 'site_name',
      scopedSlots: {
        customRender: 'site_name'
      },
    }
  ];

  // product series columns
  const productseriesColumns = [{
      title: 'Series Name',
      dataIndex: 'series_name',
      scopedSlots: {
        customRender: 'series_name',
      },
    },
    {
      title: 'Series Date',
      dataIndex: 'series_date',
      scopedSlots: {
        customRender: 'series_date'
      },
    },
    {
      title: 'Intro Date',
      dataIndex: 'intro_date',
      scopedSlots: {
        customRender: 'intro_date'
      },
    },

  ];
  // end product series columns  

  const data = [];
  const barcodeData = [];
  const shelfData = [];
  const reorderData = [];
  const priceData = [];
  const productData = [];
  const kitData = [];
  const yieldData = [];
  const productseriesData = []; // product series array

  export default {
    components: {
      SitePriceForm,
      MatrixForm,
      Autocomplete
    },
    computed: {
      ...mapState(['endPoint', 'serverType', 'profileId', 'publicUrl', 'categoriesOptions']),
      hideBackBtn(){
      if(this.activeKey == '1'){
        if(this.basicKey !== '1'){
          return true;
        }else{
          return false;
        }
      }else{
          if(this.advanceKey !== ''){
          return true;
          }else{
            return false;
          }
      }
    },
    hideNextBtn(){
      if(this.activeKey == '1'){
        if(this.basicKey !== '3'){
          return true;
        }else{
          return false;
        }
      }else{
        if(this.advanceKey !== '11'){
          return true;
        }else{
          return false;
        }
      }
    }
    },
    mounted: async function () {
      if(this.serverType == 'branch'){
        var form = document.getElementById("form-proper")
        var elements = form.elements;
        for (var i = 0, len = elements.length; i < len; ++i) {
          elements[i].readOnly = true;
        }
      }
      
      var component_x = this

      component_x.spinning = true;

      this.advanceKey = '2'
      this.advanceSelectedKey = ['2']
    
      var userId = secureStorage.getItem("userId")
      var response;

      response = await HTTPRequest.getRequest(this.endPoint + "/user_settings?module_name=kit&user_id=" + userId ,null)
      var kitSettings;
      if(response.data[0] != undefined) {
        kitSettings = JSON.parse(response.data[0].settings_json)
        component_x.recompute_cost = kitSettings.recompute_kit_cost
        component_x.recompute_price = kitSettings.recompute_kit_price
      } else {
        kitSettings = {}
      }

      response = await HTTPRequest.getRequest(this.endPoint + "/user_settings?module_name=px&user_id=" + userId ,null)
      var userSettings;
      if(response.data[0] != undefined) {
        userSettings = JSON.parse(response.data[0].settings_json)
      } else {
        userSettings = {}
      }

      response = await HTTPRequest.getRequest(this.endPoint + "/system_settings?module_name=px" ,null)
      var systemSettings;
      if(response.data[0] != undefined) {
        systemSettings = JSON.parse(response.data[0].settings_json)
      } else {
        systemSettings = {}
      }

      var mergedHash = Object.assign({}, systemSettings, userSettings);
      component_x.formSettings = mergedHash

      var units = await HTTPRequest.getRequest(component_x.endPoint + "units/get_valid_units", null);
      component_x.unitOptions = units;
      component_x.sort(component_x.unitOptions);

      var properties = await HTTPRequest.getRequest(component_x.endPoint + "properties/get_valid_properties", null);
      component_x.propertyOptions = properties;
      component_x.sort(component_x.propertyOptions);

      var brands = await HTTPRequest.getRequest(component_x.endPoint + "brands/get_valid_brands", null);
      if (brands.length > 100){
        component_x.brandOptions = []
      } else{
        component_x.brandOptions = brands;
        component_x.sort(component_x.brandOptions);
      }

      var suppliers = await HTTPRequest.getRequest(component_x.endPoint + "suppliers/get_valid_suppliers", null);
      component_x.supplierOptions = suppliers;
      component_x.sort(component_x.supplierOptions);

      var product_lines = await HTTPRequest.getRequest(component_x.endPoint + "product_lines/get_valid_tags", null);
      component_x.productLineOptions = product_lines;
      component_x.sort(component_x.productLineOptions);

      var colors = await HTTPRequest.getRequest(component_x.endPoint + "colors/get_valid_colors", null);
      component_x.colorOptions = colors;
      component_x.sort(component_x.colorOptions);

      var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites", null);
      component_x.siteOptions = sites;
      component_x.sort(component_x.siteOptions);

      component_x.categoryOptions = component_x.categoriesOptions

      //set default settings
      if(component_x.formSettings.default_vat_rate != undefined){
        component_x.default_vat_rate = component_x.formSettings.default_vat_rate;
      }
      if(component_x.formSettings.markup_computation != undefined){
        component_x.markup_computation = component_x.formSettings.markup_computation;
      }
      if(component_x.formSettings.markup_roundup != undefined){
        component_x.markup_roundup = component_x.formSettings.markup_roundup;
      }
      if(component_x.formSettings.short_name_length != undefined){
        component_x.short_name_length = component_x.formSettings.short_name_length;
      }
      if(component_x.formSettings.enable_auto_compute_price_on_markup != undefined){
        component_x.enable_auto_compute_price_on_markup = component_x.formSettings.enable_auto_compute_price_on_markup;
      }
      if(component_x.formSettings.default_markup != undefined){
        component_x.default_markup = component_x.formSettings.default_markup;
        if (component_x.enable_auto_compute_price_on_markup == true){
          component_x.product.markup_percent = component_x.default_markup;
        }
      }
      if(component_x.formSettings.disable_blank_division != undefined){
        component_x.disable_blank_division = component_x.formSettings.disable_blank_division;
      }
      if(component_x.formSettings.disable_blank_department != undefined){
        component_x.disable_blank_department = component_x.formSettings.disable_blank_department;
      }
      if(component_x.formSettings.disable_blank_section != undefined){
        component_x.disable_blank_section = component_x.formSettings.disable_blank_section;
      }
      if(component_x.formSettings.disable_blank_category != undefined){
        component_x.disable_blank_category = component_x.formSettings.disable_blank_category;
      }
      if(component_x.formSettings.disable_blank_product_line != undefined){
        component_x.disable_blank_product_line = component_x.formSettings.disable_blank_product_line;
      }
      if(component_x.formSettings.disable_blank_supplier != undefined){
        component_x.disable_blank_supplier = component_x.formSettings.disable_blank_supplier;
      }
      if(component_x.formSettings.disable_blank_brand != undefined){
        component_x.disable_blank_brand = component_x.formSettings.disable_blank_brand;
      }
      if(component_x.formSettings.disable_blank_wholesale_price != undefined){
        component_x.disable_blank_wholesale_price = component_x.formSettings.disable_blank_wholesale_price;
      }
      if(component_x.formSettings.disable_blank_least_price != undefined){
        component_x.disable_blank_least_price = component_x.formSettings.disable_blank_least_price;
      }
      if(component_x.formSettings.disable_blank_special_price != undefined){
        component_x.disable_blank_special_price = component_x.formSettings.disable_blank_special_price;
      }
      if(component_x.formSettings.disable_blank_price4 != undefined){
        component_x.disable_blank_price4 = component_x.formSettings.disable_blank_price4;
      }
      if(component_x.formSettings.disable_blank_price5 != undefined){
        component_x.disable_blank_price5 = component_x.formSettings.disable_blank_price5;
      }
      if(component_x.formSettings.disable_blank_refcode != undefined){
        component_x.disable_blank_refcode = component_x.formSettings.disable_blank_refcode;

        if (component_x.disable_blank_refcode == false){
          if(component_x.formSettings.lock_refcode != undefined){
            component_x.lock_refcode = component_x.formSettings.lock_refcode;
          }
        }
      }

      if(component_x.formSettings.enable_multiple_price != undefined){
        component_x.enable_multiple_price = component_x.formSettings.enable_multiple_price;
        if (component_x.enable_multiple_price == true) {
          component_x.costing_mode = '2';
        } else {
          component_x.costing_mode = '1';
        }
      }

      if(component_x.formSettings.package_name_format != undefined){
        component_x.package_name_format = component_x.formSettings.package_name_format;
      }

      if(component_x.formSettings.package_name_format_base != undefined){
        component_x.package_name_format_base = component_x.formSettings.package_name_format_base;
      }

      if(component_x.formSettings.change_price_cost_package_on_regular_update != undefined){
        component_x.change_price_cost_package_on_regular_update = component_x.formSettings.change_price_cost_package_on_regular_update;
      }
      if(component_x.formSettings.cost_decimal_places != undefined){
        if(component_x.formSettings.cost_decimal_places == "1") {
          component_x.cost_decimal_places = 2;
        } else {
          component_x.cost_decimal_places = 4;
        }
      }

      if(component_x.formSettings.warn_at_zero_cost_px != undefined){
        component_x.warn_at_zero_cost_px = component_x.formSettings.warn_at_zero_cost_px;
      }

      if(component_x.formSettings.warn_at_zero_price_px != undefined){
        component_x.warn_at_zero_price_px = component_x.formSettings.warn_at_zero_price_px;
      }

      if(component_x.formSettings.warn_at_price_below_cost_px != undefined){
        component_x.warn_at_price_below_cost_px = component_x.formSettings.warn_at_price_below_cost_px;
      }

      if(component_x.formSettings.warn_at_kit_cost_change != undefined){
        component_x.warn_at_kit_cost_change = component_x.formSettings.warn_at_kit_cost_change;
      }

      if(component_x.formSettings.warn_at_kit_price_change != undefined){
        component_x.warn_at_kit_price_change = component_x.formSettings.warn_at_kit_price_change;
      }

      if(component_x.formSettings.warn_at_package_cost_change != undefined){
        component_x.warn_at_package_cost_change = component_x.formSettings.warn_at_package_cost_change;
      }

      if(component_x.formSettings.warn_at_package_price_change != undefined){
        component_x.warn_at_package_price_change = component_x.formSettings.warn_at_package_price_change;
      }

      component_x.data = [];
      component_x.barcodeData = [];
      component_x.productseriesData = []; //product series
      component_x.shelfData = [];
      component_x.reorderData = [];
      component_x.priceData = [];
      component_x.kitData = [];
      component_x.productData = [];
      component_x.selectedRowKeys = [];

      sites.forEach(element => {
        component_x.productData.push({
          key: element.id,
          site_id: element.id,
          site_name: element.name
        });

        component_x.selectedRowKeys.push(element.id);
      });


      if (component_x.profileId > 0) {
        var product_data = await HTTPRequest.getRequest(component_x.endPoint + 'products/' + component_x.profileId, null)
        if (product_data == undefined) {
          component_x.$router.go()
        } else {
          if (product_data["error"] == undefined) {
            if(product_data.product_type == ''){
              component_x.prev_original_cost = product_data.original_cost;
              component_x.prev_ordering_cost = product_data.ordering_cost;
              component_x.prev_landed_cost = product_data.landed_cost;
              component_x.prev_retail_price = product_data.retail_price;
              component_x.prev_wholesale_price = product_data.wholesale_price;
              component_x.prev_least_price = product_data.least_price;
              component_x.prev_special_price = product_data.special_price;
              component_x.prev_price4 = product_data.price4;
              component_x.prev_price5 = product_data.price5;
            }

            component_x.product = product_data;
            component_x.product_properties = {
              property_id: []
            };

            //jng 01-10-2020
            if(component_x.profileId != 0){
              component_x.tax_type = product_data.tax_type;
            }else{
              component_x.tax_type = 'V';
            }

            component_x.product.sc_discount_percent = Number(product_data.sc_discount_percent) * 100
            component_x.product.pwd_discount_percent = Number(product_data.pwd_discount_percent) * 100
            
            var product_properties_data = await HTTPRequest.getRequest(component_x.endPoint + 'product_properties?product_id=' + component_x.profileId, null)
            product_properties_data.data.forEach(element => {
              component_x.product_properties.property_id.push(element.property_id); 
            });

            component_x.data = [];
            var supplier_products_data = await HTTPRequest.getRequest(component_x.endPoint + 'supplier_products?product_id=' + component_x.profileId, null)
            if (supplier_products_data.total){
              supplier_products_data.data.forEach(element => {
                component_x.data.push({
                  key: component_x.count,
                  supplier_id: element.supplier_id,
                  supplier_name: component_x.supplierOptions.find(x => x.id === element.supplier_id).name,
                  supplier_code: component_x.supplierOptions.find(x => x.id === element.supplier_id).code,
                  ordering_cost: element.ordering_cost,
                  status: element.status
                });

                component_x.count = component_x.count + 1;
              });
              component_x.product.is_alternate_supplier = true;
            }

            component_x.barcodeData = [];
            var product_barcodes_data = await HTTPRequest.getRequest(component_x.endPoint + 'product_barcodes?product_id=' + component_x.profileId, null)
            if (product_barcodes_data.total){
              product_barcodes_data.data.forEach(element => {
                component_x.barcodeData.push({
                  key: component_x.barcodeCount,
                  name: `Barcode ${component_x.barcodeCount}`,
                  barcode: element.barcode,
                  status: element.status
                });

                component_x.barcodeCount = component_x.barcodeCount + 1;
              });
            }

            // product series mounted
            var productseries_data = await HTTPRequest.getRequest(component_x.endPoint + 'product_series?product_id=' + component_x.profileId, null)
            if (productseries_data.total){
              productseries_data.data.forEach(element => {
                component_x.productseriesData.push({
                  key: component_x.productseriesCount,
                  series_name: element.series_name,
                  intro_date: moment(element.intro_date).format("MMMM DD, YYYY"),
                  series_date: moment(element.series_date).format("MMMM DD, YYYY")
                });

                component_x.productseriesCount = component_x.productseriesCount + 1;
              });
            }
            // end product series mounted


            component_x.shelfData = [];
            component_x.reorderData = [];
            component_x.selectedRowKeys = [];
            component_x.priceData = [];

            var site_products_data = await HTTPRequest.getRequest(component_x.endPoint + 'site_products?product_id=' + component_x.profileId, null)
            if (site_products_data.total){
              site_products_data.data.forEach(element => {
                if (element.shelf_code != null){
                  component_x.shelfData.push({
                    key: component_x.shelfCount,
                    site_id: element.site_id,
                    site_name: component_x.siteOptions.find(x => x.id === element.site_id).name,
                    shelf_code: element.shelf_code,
                  });

                  component_x.shelfCount = component_x.shelfCount + 1;
                }

                if (element.min_quantity == null && element.max_quantity == null){
                  //do nothing
                } else {
                  component_x.reorderData.push({
                    key: component_x.reorderCount,
                    site_id: element.site_id,
                    site_name: component_x.siteOptions.find(x => x.id === element.site_id).name,
                    min_quantity: element.min_quantity,
                    max_quantity: element.max_quantity
                  });

                  component_x.reorderCount = component_x.reorderCount + 1;
                }

                if (element.status == 'A'){
                  component_x.selectedRowKeys.push(element.site_id);
                }
              });
            }

            // Read per-site price overrides from the decoupled site_prices
            // table when decoupling is enabled for this account; otherwise
            // read from the legacy site_products table (pre-feature behavior).
            var _recipeDecouplingEnabled = false;
            try {
              var _recipeAccountSettings = await HTTPRequest.getRequest(component_x.endPoint + 'settings/accountSettings?field_name=code', null)
              if (_recipeAccountSettings && _recipeAccountSettings.value) {
                var _recipeParsed = JSON.parse(_recipeAccountSettings.value)
                _recipeDecouplingEnabled = _recipeParsed.siteProductPriceDecouplingEnabled === true || _recipeParsed.siteProductPriceDecouplingEnabled === 'true'
              }
            } catch (e) {
              _recipeDecouplingEnabled = false
            }
            var _recipePriceEndpoint = _recipeDecouplingEnabled ? 'site_prices?product_id=' : 'site_products?product_id='
            var site_prices_response = await HTTPRequest.getRequest(component_x.endPoint + _recipePriceEndpoint + component_x.profileId + '&per_page=500', null)
            // Both index endpoints return a paginated { data: [...] } payload;
            // tolerate a bare array response as well.
            var site_prices_data = (site_prices_response && site_prices_response.data) ? site_prices_response.data : (Array.isArray(site_prices_response) ? site_prices_response : [])
            if (site_prices_data && site_prices_data.length){
              site_prices_data.forEach(element => {
                component_x.priceData.push({
                  key: element.site_id,
                  id: element.id,
                  site_id: element.site_id,
                  site_name: component_x.siteOptions.find(x => x.id === element.site_id).name,
                  supplier_id: element.supplier_id,
                  original_cost: element.original_cost,
                  ordering_cost: element.ordering_cost,
                  landed_cost: element.landed_cost,
                  markup_percent: element.markup_percent,
                  retail_price: element.retail_price,
                  wholesale_price: element.wholesale_price,
                  least_price: element.least_price,
                  special_price: element.special_price,
                  price4: element.price4,
                  price5: element.price5
                });
              });
            }

            if(component_x.shelfData.length > 0){
              component_x.shelf_code_mode = "2"
            } else {
              component_x.shelf_code_mode = "1"
            }

            if(component_x.reorderData.length > 0){
              component_x.reorder_mode = "2"
            } else {
              component_x.reorder_mode = "1"
            }

            if(component_x.priceData.length > 0){
              component_x.is_site_price = true
            } else {
              component_x.is_site_price = false
            }

            const newData = [...component_x.data];
            component_x.cacheData = newData.map(item => ({ ...item }));

            const newBarcodeData = [...component_x.barcodeData];
            component_x.barcodeCacheData = newBarcodeData.map(item => ({ ...item }));

            const newShelfData = [...component_x.shelfData];
            component_x.shelfCacheData = newShelfData.map(item => ({ ...item }));

            const newReorderData = [...component_x.reorderData];
            component_x.reorderCacheData = newReorderData.map(item => ({ ...item}));

            const newPriceData = [...component_x.priceData];
            component_x.priceCacheData = newPriceData.map(item => ({ ...item}));

            const newProductData = [...component_x.productData];
            component_x.productCacheData = newProductData.map(item => ({ ...item}));
            
            // Unsave Data 
            // Formula: x = Landed Cost, y = Landed Cost w/o VAT, z = VAT Rate
            // landed_cost_no_vat = x / ( 1 + ( z / 100) )
            if(product_data.landed_cost > 0){
              component_x.product.landed_cost_no_vat = product_data.landed_cost / (1 + (component_x.default_vat_rate / 100))
            } else {
              component_x.product.landed_cost_no_vat = 0
            }
            var landed_cost_no_vat = Number(component_x.product.landed_cost_no_vat);
            component_x.product.landed_cost_no_vat = landed_cost_no_vat.toFixed(component_x.cost_decimal_places);

            if (product_data.intro_date == null){
              component_x.product.intro_date = null
            } else {
              component_x.product.intro_date = moment(product_data.intro_date);
            }

            if (product_data.reference_date == null){
              component_x.product.reference_date = null
            } else {
              component_x.product.reference_date = moment(product_data.reference_date);
            }

            if (product_data["filename"] != null) {
              component_x.fileList = [{
                uid: product_data['id'],
                name: product_data["filename"],
                status: 'done',
                url: component_x.publicUrl + 'product_images/' + product_data["filename"]
              }]
            } else {
              component_x.fileList = []
            }

            component_x.imageLoaded = true

            if (product_data.category_id > 0) {
              var parent_cat = component_x.categoryOptions[0].value
              component_x.cascader_category = [parent_cat, product_data.division_id, product_data.department_id, product_data.section_id, product_data.category_id]
            }

            if (product_data.salesman_commission > 0) {
              component_x.is_enable_sales_commission = true;
            }

            if (product_data.supplier_commission > 0) {
              component_x.is_enable_supplier_commission = true;
            }

            if (product_data.retail_price == 0 || product_data.wholesale_price == 0 || product_data.least_price == 0 || product_data.special_price == 0 || product_data.price4 == 0 || product_data.price5 == 0){
              component_x.allow_zero = true;
            }

            component_x.kitData = [];
            var product_compositions_data = [];
            product_compositions_data = await HTTPRequest.getRequest(component_x.endPoint + 'product_compositions?product_type=R&package_product_id=' + component_x.profileId, null)
            if(product_compositions_data.total > 0){
              product_compositions_data.data.forEach(element => {
                component_x.kitData.push({
                  key: component_x.kitCount,
                  regular_product_id: element.regular_product_id,
                  quantity: element.quantity,
                  barcode: element.product_detail.barcode,
                  decrypted_quantity: element.decrypted_quantity,
                  short_name: element.product_detail.short_name,
                  stock_no: element.product_detail.stock_no,
                  product_type: element.product_detail.product_type,
                  original_cost: element.product_detail.original_cost,
                  ordering_cost: element.product_detail.ordering_cost,
                  cost: element.product_detail.landed_cost,
                  retail_price: element.product_detail.retail_price,
                  wholesale_price: element.product_detail.wholesale_price,
                  least_price: element.product_detail.least_price,
                  special_price: element.product_detail.special_price,
                  price4: element.product_detail.price4,
                  price5: element.product_detail.price5,
                  status: element.status
                });
                component_x.kitCount = component_x.kitCount + 1;
              });
            }

            component_x.yieldData.push({
                quantity: product_data.yield_quantity,
                tolerance: product_data.tolerance_quantity,
                regular_product_id: product_data.finished_product_id,
                barcode: product_data.finished_product_barcode,
                name: product_data.finished_product_name
            })
            
            const newYieldData = [...component_x.yieldData];
            const newKitData = [...component_x.kitData];
            component_x.kitCacheData = newKitData.map(item => ({ ...item}));
            component_x.yieldCacheData = newYieldData.map(item => ({ ...item}));

          } else {
            component_x.errors = product_data["error"].split(",");
          }
        }
      }

      component_x.spinning = false;
    },
    props:['productType'],
    data() {
      this.cacheData = data.map(item => ({ ...item }));
      this.barcodeCacheData = barcodeData.map(item => ({ ...item}));
      this.shelfCacheData = shelfData.map(item => ({ ...item}));
      this.reorderCacheData = reorderData.map(item => ({ ...item}));
      this.priceCacheData = priceData.map(item => ({ ...item}));
      this.productCacheData = productData.map(item => ({ ...item}));
      this.kitCacheData = kitData.map(item => ({ ...item}));
      this.yieldCacheData = yieldData.map(item => ({ ...item}));
      return {
        data,
        columns,
        barcodeData,
        barcodeColumns,
        shelfData,
        shelfColumns,
        reorderData,
        reorderColumns,
        priceData,
        priceColumns,
        productData,
        productColumns,
        kitData,
        kitColumns,
        yieldColumns,
        yieldData: [],
        matrixData: [],
        basicSelectedKeys:[], // array for selectedKeys in a-menu basic
        advanceSelectedKeys:[], // array for selectedKeys in a-menu advanced

        count: 1,
        barcodeCount: 1,
        shelfCount: 1,
        reorderCount: 1,
        priceCount: 1,
        kitCount: 1,
        yieldCount: 1,

        fetching: false,
        spinning: false,
        formSettings: { isAdmin: false },
        searchFilter: "name",

        updateKey: 0,
        activeKey: ['1'],
        advanceSelectedKey: ['1'],
        basicKey: "1",
        advanceKey: "1",
        accordion: true,
        unitOptions: [],
        productLineOptions: [],
        colorOptions: [],
        is_enable_sales_commission: false,
        is_enable_supplier_commission: false,

        alternate_supplier_id: null,
        showAdvancedInfo: false,
        selectedRowKeys: [],
        targetData: [],
        targetKey: 0,
        tax_type: "V",
        
        product: {
          tax_type: null,
          status: "A",
          landed_cost: "",
          landed_cost_no_vat: 0,
          original_cost: "",
          ordering_cost: "",
          last_discount_text: "",
          original_price: "",
          retail_price: "",
          special_price: "",
          least_price: "",
          wholesale_price: "",
          markup_percent: 0,
          price4: "",
          price5: "",
          is_inventory: true,
          salesman_commission: 0,
          supplier_commission: 0,
          product_type: this.productType,
          content_quantity: 1
        },

        //  product series data
        productseriesKey: '',
        productseriesButton: 'add', //change button to add and delete
        productseriesCount: 1, // temporary key
        productseriesData, // array item to push objects
        productseriesColumns, // table columns
        product_series: {
          key: null,
          intro_date: null,
          series_name: '',
          series_date: null,
          status: '',
        },
        // end product series data


        markup_wholesale_price: '',
        markup_special_price: '',
        markup_least_price: '',
        markup_price4: '',
        markup_price5: '',

        allow_zero: false,

        costing_mode: "1",
        shelf_code_mode: "1",
        reorder_mode: "1",
        product_properties: {},
        site_products: {},
        is_site_price: false,
        regular_product_id: 0,
        regular_name: 0,
        regular_short_name: 0,

        costingOptions: [
          {key: "1", value: "Basic (Default)"},
          {key: "2", value: "Advanced"}
        ],

        shelfCodeOptions: [
          {key: "1", value: "For all sites"},
          {key: "2", value: "For multiple sites"}
        ],

        reorderOptions: [
          {key: "1", value: "For all sites"},
          {key: "2", value: "For multiple sites"}
        ],

        statusOptions: [
          {key: "A", value: "Active"},
          {key: "I", value: "Inactive"}
        ],
        
        cascader_category: [],
        categoryOptions: [],
        brandOptions: [],
        supplierOptions: [],
        propertyOptions: [],
        dateFormat: 'MM-DD-YYYY',
        authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
        authHeadersImage: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
        errors: [],
        warnings: [],
        tableErrors: [],
        
        previewVisible: false,
        previewImage: '',
        fileList: [],
        imageLoaded: true,

        componentKey: 0,
        visible: false,
        priceId: 0,

        tmp_original_cost: 0,
        tmp_ordering_cost: 0,
        tmp_landed_cost: 0,
        tmp_retail_price: 0,
        tmp_wholesale_price: 0,
        tmp_least_price: 0,
        tmp_special_price: 0,                        
        tmp_price4: 0,
        tmp_price5: 0,

        prev_original_cost: 0,
        prev_ordering_cost: 0,
        prev_landed_cost: 0,
        prev_retail_price: 0,
        prev_wholesale_price: 0,
        prev_least_price: 0,
        prev_special_price: 0,
        prev_price4: 0,
        prev_price5: 0,

        has_package: false,
        has_matrix_item: false,
        modalVisible: false,

        recompute_cost: false,
        recompute_price: false,

        //set value
        default_vat_rate: 12,
        markup_computation: "2",
        short_name_length: "50",
        enable_auto_compute_price_on_markup: false,
        default_markup: "0",
        markup_roundup: ".05",
        cost_decimal_places: 2,
        change_price_cost_package_on_regular_update: false,
        package_name_format_base: false,
        package_name_format: "1",
        lock_refcode: false,
        enable_multiple_price: false,
        warn_at_zero_cost_px: false,
        warn_at_zero_price_px: false,
        warn_at_price_below_cost_px: false,
        warn_at_kit_cost_change: false,
        warn_at_kit_price_change: false,
        warn_at_package_cost_change: false,
        warn_at_package_price_change: false,
        disable_blank_division: false,
        disable_blank_department: false,
        disable_blank_section: false,
        disable_blank_category: false,
        disable_blank_product_line: false,
        disable_blank_supplier: false,
        disable_blank_brand: false,
        disable_blank_wholesale_price: false,
        disable_blank_least_price: false,
        disable_blank_special_price: false,
        disable_blank_price4: false,
        disable_blank_price5: false,
        disable_blank_refcode: false
      }
    },
    watch: {
      tax_type: function() {
        // this.product.tax_type = this.tax_type
        this.computeLandedCostNoTax();
      },
      recompute_cost: function() {
        this.computeCostAction();
      },
      recompute_price: function() {
        this.computePriceAction();
      }
    },
    methods: {
      moment,
      computeCostAction(){
        if(this.recompute_cost == true){
          this.product.original_cost = 0;
          this.product.ordering_cost = 0;
          this.product.landed_cost = 0;

          this.kitData.forEach(element => {
            var original_cost = this.computeKit(this.product.original_cost, element.original_cost, element.quantity);
            this.product.original_cost = original_cost;

            var ordering_cost = this.computeKit(this.product.ordering_cost, element.ordering_cost, element.quantity);
            this.product.ordering_cost = ordering_cost;

            var landed_cost = this.computeKit(this.product.landed_cost, element.cost, element.quantity);
            this.product.landed_cost = landed_cost;
          });
        }
      },
      computePriceAction(){
        if(this.recompute_price == true){
          this.product.retail_price = 0;
          this.product.wholesale_price = 0;
          this.product.least_price = 0;
          this.product.special_price = 0;
          this.product.price4 = 0;
          this.product.price5 = 0;

          this.kitData.forEach(element => {
            var retail_price = this.computeKit(this.product.retail_price, element.retail_price, element.quantity);
            this.product.retail_price = retail_price;

            var wholesale_price = this.computeKit(this.product.wholesale_price, element.wholesale_price, element.quantity);
            this.product.wholesale_price = wholesale_price;

            var least_price = this.computeKit(this.product.least_price, element.least_price, element.quantity);
            this.product.least_price = least_price;

            var special_price = this.computeKit(this.product.special_price, element.special_price, element.quantity);
            this.product.special_price = special_price;

            var price4 = this.computeKit(this.product.price4, element.price4, element.quantity);
            this.product.price4 = price4;

            var price5 = this.computeKit(this.product.price5, element.price5, element.quantity);
            this.product.price5 = price5;
          });
        }
      },
      computeKit(key, value, qty){
        var x = key + (value * qty)
        return x;
      },
      async handleSearch(value){
        this.fetching = true;
        var brands = await HTTPRequest.getRequest(this.endPoint + "/brands/get_valid_brands?name=" + value , null, null)   
        this.brandOptions = brands
        this.fetching = false;
      },

      //alternate supplier table
      onDelete(key) {
        const dataSource = [...this.data];
        this.data = dataSource.filter(item => item.key !== key);
      },
      validateForm(){
        if (this.tableErrors.length) {
          return this.tableErrors.length;
        } else {
          this.errors = [];
          this.errors.push(ValidateField.required('Name', this.product.name));
          this.errors.push(ValidateField.charMinAndMax('Name', this.product.name, 0, 255));
          this.errors.push(ValidateField.required('Short Name', this.product.short_name));
          this.errors.push(ValidateField.charMinAndMax('Short Name', this.product.short_name, 0, parseInt(this.short_name_length)));
          this.errors.push(ValidateField.required('Stock No.', this.product.stock_no));
          this.errors.push(ValidateField.charMinAndMax('Stock No.', this.product.stock_no, 0, 30));
          // this.errors.push(ValidateField.required('Barcode', this.product.barcode));
          this.errors.push(ValidateField.charMinAndMax('Barcode', this.product.barcode, 0, 20));
          this.errors.push(ValidateField.required('Unit', this.product.unit_id));
    
            if(this.disable_blank_supplier == true){
              this.errors.push(ValidateField.required('Supplier', this.product.supplier_id));
            }
            if(this.disable_blank_division == true){
              this.errors.push(ValidateField.required('Division', this.product.division_id));
            }
            if(this.disable_blank_department == true){
              this.errors.push(ValidateField.required('Department', this.product.department_id));
            }
            if(this.disable_blank_section == true){
              this.errors.push(ValidateField.required('Section', this.product.section_id));
            }
            if(this.disable_blank_category == true){
              this.errors.push(ValidateField.required('Category', this.product.category_id));
            }
            if(this.disable_blank_brand == true){
              this.errors.push(ValidateField.required('Brand', this.product.brand_id));
            }
            if(this.disable_blank_product_line == true){
              this.errors.push(ValidateField.required('Product Line', this.product.product_line_id));
            }
          

          if(this.disable_blank_refcode == true){
            this.errors.push(ValidateField.required('Reference Code', this.product.reference_code));
          }
          
          this.errors.push(ValidateField.requiredButAllowZero('Ordering Cost', this.product.ordering_cost));
          this.errors.push(ValidateField.requiredButAllowZero('Landed Cost', this.product.landed_cost));
          this.errors.push(ValidateField.requiredButAllowZero('Markup Percent', this.product.markup_percent));

          if(this.allow_zero == true){
            this.errors.push(ValidateField.requiredButAllowZero('Retail Price', this.product.retail_price))
          } else {
            if(this.product.retail_price == ''){
              this.errors.push(ValidateField.required('Retail Price', this.product.retail_price));
            } else {
              this.errors.push(ValidateField.greaterThanZero('Retail Price', this.product.retail_price));
            }
          }

          if(this.enable_multiple_price == true){
            if(this.disable_blank_wholesale_price == true){
              if(this.allow_zero == true){
                this.errors.push(ValidateField.requiredButAllowZero('Wholesale Price', this.product.wholesale_price));
              } else {
                if(this.product.wholesale_price == ''){
                  this.errors.push(ValidateField.required('Wholesale Price', this.product.wholesale_price));
                } else {
                  this.errors.push(ValidateField.greaterThanZero('Wholesale Price', this.product.wholesale_price));
                }
              }
            }
            if(this.disable_blank_least_price == true){
              if(this.allow_zero == true){
                this.errors.push(ValidateField.requiredButAllowZero('Least Price', this.product.least_price));
              } else {
                if(this.product.least_price == ''){
                  this.errors.push(ValidateField.required('Least Price', this.product.least_price));
                } else {
                  this.errors.push(ValidateField.greaterThanZero('Least Price', this.product.least_price));
                }
              }
            }
            if(this.disable_blank_special_price == true){
              if(this.allow_zero == true){
                this.errors.push(ValidateField.requiredButAllowZero('Special Price', this.product.special_price));
              } else {
                if(this.product.special_price == ''){
                  this.errors.push(ValidateField.required('Special Price', this.product.special_price));
                } else {
                  this.errors.push(ValidateField.greaterThanZero('Special Price', this.product.special_price));
                }
              }
            }
            if(this.disable_blank_price4 == true){
              if(this.allow_zero == true){
                this.errors.push(ValidateField.requiredButAllowZero('Price4', this.product.price4));
              } else {
                if(this.product.price4 == ''){
                  this.errors.push(ValidateField.required('Price4', this.product.price4));
                } else {
                  this.errors.push(ValidateField.greaterThanZero('Price4', this.product.price4));
                }
              }
            }
            if(this.disable_blank_price5 == true){
              if(this.allow_zero == true){
                this.errors.push(ValidateField.requiredButAllowZero('Price5', this.product.price5));
              } else {
                if(this.product.price5 == ''){
                  this.errors.push(ValidateField.required('Price5', this.product.price5));
                } else {
                  this.errors.push(ValidateField.greaterThanZero('Price5', this.product.price5));
                }
              }
            }
          }
          
 
        if(this.kitData.length == 0){
          let type = ''
          if(this.productType == 'V'){
            type = 'virtual '
          }
          this.errors.push(`There are no components selected for this recipe`)
        }

        if(this.yieldData.length == 0){
          this.errors.push(`There is no yield product selected for this recipe.`)
        }
        

          this.errors = this._.compact(this.errors);
          return this.errors.length;
        }
        
      },
      checkWarning(){
        this.warnings = [];
        if(this.warn_at_zero_cost_px == true){
          if(this.product.original_cost == 0 || this.product.original_cost == undefined){
            this.warnings.push(this.openNotificationWithIcon('warn', 1, "Original Cost"));
          }
        }

        if(this.enable_multiple_price == true){
          if(this.warn_at_zero_price_px == true){
            if(this.product.wholesale_price == 0 || this.product.wholesale_price == undefined){
              this.warnings.push(this.openNotificationWithIcon('warn', 2, "Wholesale Price"));
            } 
            
            if(this.product.least_price == 0 || this.product.least_price == undefined){
              this.warnings.push(this.openNotificationWithIcon('warn', 2, "Least Price"));
            }
            
            if(this.product.special_price == 0 || this.product.special_price == undefined){
              this.warnings.push(this.openNotificationWithIcon('warn', 2, "Special Price"));
            }
            
            if(this.product.price4 == 0 || this.product.price4 == undefined){
              this.warnings.push(this.openNotificationWithIcon('warn', 2, "Price4"));
            }

            if(this.product.price5 == 0 || this.product.price5 == undefined){
              this.warnings.push(this.openNotificationWithIcon('warn', 2, "Price5"));
            }
          }
        }

        if(this.warn_at_price_below_cost_px == true){
          if(this.product.retail_price < this.product.landed_cost){
            this.warnings.push(this.openNotificationWithIcon('warn', 3, "Retail Price"));
          } 

          if(this.enable_multiple_price == true){
            if(this.product.wholesale_price < this.product.landed_cost){
              this.warnings.push(this.openNotificationWithIcon('warn', 3, "Wholesale Price"));
            } 
            
            if(this.product.least_price < this.product.landed_cost){
              this.warnings.push(this.openNotificationWithIcon('warn', 3, "Least Price"));
            }
            
            if(this.product.special_price < this.product.landed_cost){
              this.warnings.push(this.openNotificationWithIcon('warn', 3, "Special Price"));
            }
            
            if(this.product.price4 < this.product.landed_cost){
              this.warnings.push(this.openNotificationWithIcon('warn', 3, "Price4"));
            }

            if(this.product.price5 < this.product.landed_cost){
              this.warnings.push(this.openNotificationWithIcon('warn', 3, "Price5"));
            }    
          }
        }

        if(this.warn_at_package_cost_change == true && this.product.product_type == '' && this.profileId > 0){
          if(this.prev_original_cost != this.product.original_cost){
            this.warnings.push(this.openNotificationWithIcon('warn', 4, "Original Cost"));
          }

          if(this.prev_ordering_cost != this.product.ordering_cost){
            this.warnings.push(this.openNotificationWithIcon('warn', 4, "Ordering Cost"));
          }

          if(this.prev_landed_cost != this.product.landed_cost){
            this.warnings.push(this.openNotificationWithIcon('warn', 4, "Landed Cost"));
          }
        }

        if(this.warn_at_package_price_change == true && this.product.product_type == '' && this.profileId > 0){
          if(this.prev_retail_price != this.product.retail_price){
            this.warnings.push(this.openNotificationWithIcon('warn', 4, "Retail Price"));
          }

          if(this.enable_multiple_price == true){
            if(this.prev_wholesale_price != this.product.wholesale_price){
              this.warnings.push(this.openNotificationWithIcon('warn', 4, "Wholesale Price"));
            }

            if(this.prev_least_price != this.product.least_price){
              this.warnings.push(this.openNotificationWithIcon('warn', 4, "Least Price"));
            }

            if(this.prev_special_price != this.product.special_price){
              this.warnings.push(this.openNotificationWithIcon('warn', 4, "Special Price"));
            }

            if(this.prev_price4 != this.product.price4){
              this.warnings.push(this.openNotificationWithIcon('warn', 4, "Price4"));
            }

            if(this.prev_price5 != this.product.price5){
              this.warnings.push(this.openNotificationWithIcon('warn', 4, "Price5"));
            }
          }
        }
      },
      handleAdd() {
        const { count } = this;
        if (this.data.find(x => x.supplier_id === this.alternate_supplier_id)){
          alert("Supplier Already Exist");
        } else {
          if (this.supplierOptions.find(x => x.id === this.alternate_supplier_id)){

            this.data.push({
              key: count,
              supplier_id: this.alternate_supplier_id,
              supplier_name: this.supplierOptions.find(x => x.id === this.alternate_supplier_id).name,
              supplier_code: this.supplierOptions.find(x => x.id === this.alternate_supplier_id).code,
              ordering_cost: 0,
              status: 'A'
            });

            this.edit(count)
            this.count = count + 1;
          } else {
            alert("Please select supplier");
          }
        }
      },
      constructName(field){
        //  2 <unit> (<quantity>) <Based Product Name>
        //  3 <Based Product Name> <unit>
        //  4 <unit>: <Based Product Name>
        //  1 <Based Product Name> <unit> (<quantity>)
        if(this.package_name_format == '2'){
          if(field == 'short_name'){
            this.product.short_name = this.product.unit_code + ' (' + this.product.content_quantity + ') '+ this.regular_short_name
          } else {
            this.product.name = this.product.unit_code + ' (' + this.product.content_quantity + ') '+ this.regular_name
          }
        } else if(this.package_name_format == '3'){
          if(field == 'short_name'){
            this.product.short_name = this.regular_short_name + ' ' + this.product.unit_code
          } else {
            this.product.name = this.regular_name + ' ' + this.product.unit_code
          }
        } else if(this.package_name_format == '4'){
          if(field == 'short_name'){
            this.product.short_name = this.product.unit_code + ': ' + this.short_name
          } else {
            this.product.name = this.product.unit_code + ': ' + this.regular_name
          }
        } else {
          if(field == 'short_name'){
            this.product.short_name = this.regular_short_name + ' ' + this.product.unit_code + ' ' + this.product.content_quantity
          } else {
            this.product.name = this.regular_name + ' ' + this.product.unit_code + ' ' + this.product.content_quantity
          }
        }
      },
      handleChangeTable(value, key, column) {
        const newData = [...this.data];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target[column] = value;
          this.data = newData;
        }
      },
      edit(key) {
        const newData = [...this.data];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target.editable = true;
          this.data = newData;
        }
      },
      save(key) {
        const newData = [...this.data];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          delete target.editable;
          this.data = newData;
          this.cacheData = newData.map(item => ({ ...item }));
        }
      },
      cancel(key) {
        const newData = [...this.data];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          Object.assign(target, this.cacheData.filter(item => key === item.key)[0]);
          delete target.editable;
          this.data = newData;
        }
      },
      //end alternate supplier table

      //kit table
      kitOnDelete(key) {
        const dataSource = [...this.kitData];
        this.kitData = dataSource.filter(item => item.key !== key);

        this.computeCostAction();
        this.computePriceAction();
      },
      yieldOnDelete(key) {
        const dataSource = [...this.yieldData];
        this.yieldData = dataSource.filter(item => item.key !== key);
      },
      kitHandleChangeTable(value, key, column) {
        const newData = [...this.kitData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target[column] = value;
          this.kitData = newData;
        }
      },
      yieldHandleChangeTable(value, key, column) {
        const newData = [...this.yieldData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target[column] = value;
          this.yieldData = newData;
        }
      },
      kitEdit(key) {
        const newData = [...this.kitData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target.editable = true;
          this.kitData = newData;
        }
      },
      yieldEdit(key){
          const newData = [...this.yieldData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target.editable = true;
          this.yieldData = newData;
        }
      },
      kitSave(key) {
        const newData = [...this.kitData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          this.tableErrors = [];
          if (target.decrypted_quantity == "") {
            this.tableErrors.push("Please input quantity");
            this.tableErrors = this._.compact(this.tableErrors);
            return this.tableErrors.length;
          } else {
            delete target.editable;
            this.kitData = newData;
            this.kitCacheData = newData.map(item => ({ ...item }));
            this.computeCostAction();
            this.computePriceAction();
          }
          
        }
      },
      yieldSave(key) {
        const newData = [...this.yieldData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          this.tableErrors = [];
          if (target.quantity == "") {
            this.tableErrors.push("Please input quantity");
            this.tableErrors = this._.compact(this.tableErrors);
            return this.tableErrors.length;
          } else {
            console.log("ME HERE")
            delete target.editable;
            this.yieldData = newData;
            this.yieldCacheData = newData.map(item => ({ ...item }));
          }
          
        }
      },
      kitCancel(key) {
        const newData = [...this.kitData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          if (target.kit_code == "") {
            const dataSource = [...this.kitData];
            this.kitData = dataSource.filter(item => item.key !== key);
          } else {
            Object.assign(target, this.kitCacheData.filter(item => key === item.key)[0]);
            delete target.editable;
            this.kitData = newData;
          }

          this.computeCostAction();
          this.computePriceAction();
        }
      },
      yieldCancel(key) {
        const newData = [...this.yieldData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          if (target.kit_code == "") {
            const dataSource = [...this.yieldData];
            this.yieldData = dataSource.filter(item => item.key !== key);
          } else {
            Object.assign(target, this.yieldCacheData.filter(item => key === item.key)[0]);
            delete target.editable;
            this.yieldData = newData;
          }
        }
      },

      //barcodes
      barcodeOnDelete(key) {
        const dataSource = [...this.barcodeData];
        this.barcodeData = dataSource.filter(item => item.key !== key);
      },
      barcodeHandleAdd() {
        const { barcodeCount } = this;
        this.barcodeData.push({
          key: barcodeCount,
          name: `Barcode ${barcodeCount}`,
          barcode: "",
          status: 'A'
        });

        this.barcodeEdit(barcodeCount);
        this.barcodeCount = barcodeCount + 1;
      },
      barcodeHandleChangeTable(value, key, column) {
        if(column == 'status'){
          if(value == true){
            value = 'A'
          } else {
            value = 'I'
          }
        }

        const newData = [...this.barcodeData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target[column] = value;
          this.barcodeData = newData;
        }
      },
      barcodeEdit(key) {
        const newData = [...this.barcodeData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target.editable = true;
          this.barcodeData = newData;
        }
      },
      barcodeSave(key) {
        const newData = [...this.barcodeData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          this.tableErrors = [];
          if (target.barcode == "") {
            this.tableErrors.push("Please input alternate barcode");
            this.tableErrors = this._.compact(this.tableErrors);
            return this.tableErrors.length;
          } else {
            if (this.barcodeCacheData.find(x => x.barcode === target.barcode)){
              alert("Barcode Already Exist");
            } else {
              delete target.editable;
              this.barcodeData = newData;
              this.barcodeCacheData = newData.map(item => ({ ...item }));
            }
          }
          
        }
      },
      barcodeCancel(key) {
        const newData = [...this.barcodeData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          if (target.barcode == "") {
            const dataSource = [...this.barcodeData];
            this.barcodeData = dataSource.filter(item => item.key !== key);
          } else {
            Object.assign(target, this.barcodeCacheData.filter(item => key === item.key)[0]);
            delete target.editable;
            this.barcodeData = newData;
          }
          
        }
      },
      //end barcodes

      //shelfcode
      shelfOnDelete(key) {
        const dataSource = [...this.shelfData];
        this.shelfData = dataSource.filter(item => item.key !== key);
      },
      shelfHandleAdd() {
        const { shelfCount } = this;
        if (this.shelfData.find(x => x.site_id === this.site_products.site_id)){
          alert("Site Already Exist");
        } else {
          if (this.siteOptions.find(x => x.id === this.site_products.site_id)){

            this.shelfData.push({
              key: shelfCount,
              site_id: this.site_products.site_id,
              site_name: this.siteOptions.find(x => x.id === this.site_products.site_id).name,
              shelf_code: "",
            });

            this.shelfEdit(shelfCount);
            this.shelfCount = shelfCount + 1;
          } else {
            alert("Please select site");
          }
        }
      },
      shelfHandleChangeTable(value, key, column) {
        const newData = [...this.shelfData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target[column] = value;
          this.shelfData = newData;
        }
      },
      shelfEdit(key) {
        const newData = [...this.shelfData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target.editable = true;
          this.shelfData = newData;
        }
      },
      shelfSave(key) {
        const newData = [...this.shelfData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          this.tableErrors = [];
          if (target.shelf_code == "") {
            this.tableErrors.push("Please input site shelf code");
            this.tableErrors = this._.compact(this.tableErrors);
            return this.tableErrors.length;
          } else {
            delete target.editable;
            this.shelfData = newData;
            this.shelfCacheData = newData.map(item => ({ ...item }));
          }
          
        }
      },
      shelfCancel(key) {
        const newData = [...this.shelfData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          if (target.shelf_code == "") {
            const dataSource = [...this.shelfData];
            this.shelfData = dataSource.filter(item => item.key !== key);
          } else {
            Object.assign(target, this.shelfCacheData.filter(item => key === item.key)[0]);
            delete target.editable;
            this.shelfData = newData;
          }
        }
      },
      //end shelfcode

      //reorder
      reorderOnDelete(key) {
        const dataSource = [...this.reorderData];
        this.reorderData = dataSource.filter(item => item.key !== key);
      },
      reorderHandleAdd() {
        const { reorderCount } = this;
        if (this.reorderData.find(x => x.site_id === this.site_products.site_id)){
          alert("Site Already Exist");
        } else {
          if (this.siteOptions.find(x => x.id === this.site_products.site_id)){

            this.reorderData.push({
              key: reorderCount,
              site_id: this.site_products.site_id,
              site_name: this.siteOptions.find(x => x.id === this.site_products.site_id).name,
              min_quantity: 0,
              max_quantity: 0
            });

            this.reorderEdit(reorderCount);
            this.reorderCount = reorderCount + 1;
          } else {
            alert("Please select site");
          }
        }
      },
      reorderHandleChangeTable(value, key, column) {
        const newData = [...this.reorderData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target[column] = value;
          this.reorderData = newData;
        }
      },
      reorderEdit(key) {
        const newData = [...this.reorderData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          target.editable = true;
          this.reorderData = newData;
        }
      },
      reorderSave(key) {
        const newData = [...this.reorderData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          delete target.editable;
          this.reorderData = newData;
          this.reorderCacheData = newData.map(item => ({ ...item }));
        }
      },
      reorderCancel(key) {
        const newData = [...this.reorderData];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
          Object.assign(target, this.reorderCacheData.filter(item => key === item.key)[0]);
          delete target.editable;
          this.reorderData = newData;
        }
      },
      //end reorder

      //pricing
      priceOnDelete(key) {
        const dataSource = [...this.priceData];
        this.priceData = dataSource.filter(item => item.key !== key);
      },
      //end pricing
      
      formattedDisplay(result) {
        return result.name
      },
      productsEndpoint(input) {
        return this.endPoint + 'products?search_type=P&' + this.searchFilter + '=' + input
      },
      getProductForKit: async function(group) {
        var searchProduct = group.selectedObject;
        this.kitData.push({
          key: this.kitCount,
          regular_product_id: searchProduct.id,
          quantity: 1,
          barcode: searchProduct.barcode,
          short_name: searchProduct.short_name,
          stock_no: searchProduct.stock_no,
          product_type: searchProduct.product_type,
          original_cost: searchProduct.original_cost,
          ordering_cost: searchProduct.ordering_cost,
          cost: searchProduct.landed_cost,
          retail_price: searchProduct.retail_price,
          wholesale_price: searchProduct.wholesale_price,
          least_price: searchProduct.least_price,
          special_price: searchProduct.special_price,
          price4: searchProduct.price4,
          price5: searchProduct.price5,
          status: 'A',
          unit_code: searchProduct.unit_code
        });

        this.kitEdit(this.kitCount);
        this.kitCount++;
      },
      getProductForYield: async function(group) {
        if(this.yieldData.length == 0){
            var searchProduct = group.selectedObject;
            this.yieldData.push({
              key: this.yieldCount,
              regular_product_id: searchProduct.id,
              quantity: 1,
              barcode: searchProduct.barcode,
              short_name: searchProduct.short_name,
              name:   searchProduct.name
            });
            this.yieldEdit(this.yieldCount);
            this.yieldCount++;
        } else {
            this.$notification['error']({
              message: 'Only one finished good allowed per recipe',
              description: "Please delete the current product yield before adding"
            });
        }
        
      },
      getProduct: async function(group) {
        var searchProduct = group.selectedObject;
        this.product = searchProduct
        this.product.product_type = this.productType
        this.regular_product_id = searchProduct.id
        this.regular_name = searchProduct.name
        this.regular_short_name = searchProduct.short_name

        this.tmp_original_cost = group.selectedObject.original_cost
        this.tmp_ordering_cost = group.selectedObject.ordering_cost
        this.tmp_landed_cost = group.selectedObject.landed_cost
        this.tmp_retail_price = group.selectedObject.retail_price
        this.tmp_wholesale_price = group.selectedObject.wholesale_price
        this.tmp_least_price = group.selectedObject.least_price
        this.tmp_special_price = group.selectedObject.special_price
        this.tmp_price4 = group.selectedObject.price4
        this.tmp_price5 = group.selectedObject.price5

        this.product_properties = {
          property_id: []
        };
        
        Object.assign(this.product, {
          original_cost: "",
          ordering_cost: "",
          landed_cost: "",
          retail_price: "",
          wholesale_price: "",
          least_price: "",
          special_price: "",
          price4: "",
          price5: ""
        });
        
        var product_properties_data = await HTTPRequest.getRequest(this.endPoint + 'product_properties?product_id=' + this.regular_product_id, null)
        product_properties_data.data.forEach(element => {
          this.product_properties.property_id.push(element.property_id); 
        });

        if(searchProduct.landed_cost > 0){
          this.product.landed_cost_no_vat = searchProduct.landed_cost / (1 + (this.default_vat_rate / 100))
        } else {
          this.product.landed_cost_no_vat = 0
        }
        var landed_cost_no_vat = Number(this.product.landed_cost_no_vat);
        this.product.landed_cost_no_vat = landed_cost_no_vat.toFixed(this.cost_decimal_places);

        if (searchProduct.intro_date == null){
          this.product.intro_date = null
        } else {
          this.product.intro_date = moment(searchProduct.intro_date);
        }

        if (searchProduct.reference_date == null){
          this.product.reference_date = null
        } else {
          this.product.reference_date = moment(searchProduct.reference_date);
        }

        if (searchProduct["filename"] != null) {
          this.fileList = [{
            uid: searchProduct['id'],
            name: searchProduct["filename"],
            status: 'done',
            url: this.publicUrl + 'product_images/' + searchProduct["filename"]
          }]
        } else {
          this.fileList = []
        }

        this.imageLoaded = true

        if (searchProduct.category_id > 0) {
          var parent_cat = this.categoryOptions[0].value
          this.cascader_category = [parent_cat, searchProduct.division_id, searchProduct.department_id, searchProduct.section_id, searchProduct.category_id]
        }

        if (searchProduct.salesman_commission > 0) {
          this.is_enable_sales_commission = true;
        }

        if (searchProduct.supplier_commission > 0) {
          this.is_enable_supplier_commission = true;
        }
      },
      updatePackagePrice(){
        if (this.change_price_cost_package_on_regular_update == true){
          let qty = Number(this.product.content_quantity);
          Object.assign(this.product, {
            original_cost: Number(this.tmp_original_cost) * qty,
            ordering_cost: Number(this.tmp_ordering_cost) * qty,
            landed_cost: Number(this.tmp_landed_cost) * qty,
            retail_price: Number(this.tmp_retail_price) * qty,
            wholesale_price: Number(this.tmp_wholesale_price) * qty,
            least_price: Number(this.tmp_least_price) * qty,
            special_price: Number(this.tmp_special_price) * qty,
            price4: Number(this.tmp_price4) * qty,
            price5: Number(this.tmp_price5) * qty
          });
        }
        
        if(this.productType == 'P'){
          this.constructName("name");

          if (this.package_name_format_base == true){
            this.constructName("short_name");
          }
        }
      },
      closeDrawer(){
        this.onClose()
      },
      setTargetData(value){
        if(this.productType == 'P'){
          //do nothing
        } else {
          var selectedRowKeys = this.selectedRowKeys;
          if(selectedRowKeys.filter(item => item === value.site_id)){
            this.selectedRowKeys.push(value.site_id);
          }
        }

        this.priceData.push(value);
      },
      setMatrixData(value){
        this.matrixData = value;
      },
      updateTargetData(value){
        this.priceData = value;
      },

      onClose() { 
        this.visible = false
      },
      showDrawer(key) {
        this.componentKey++
        this.targetKey = key
        this.visible = true
      },

      handleCancel () {
        this.previewVisible = false
      },
      handlePreview (file) {
        this.previewImage = file.url || file.thumbUrl
        this.previewVisible = true
      },
      handleChange ({ fileList }) {
        this.fileList = fileList
      },
      uploadProductImage() {
        return this.endPoint + 'products/upload_image'
      },
      
      // Advanced Info
      showAdvancedInfoDiv(){
        this.showAdvancedInfo ? this.showAdvancedInfo = false : this.showAdvancedInfo = true
      },

      computeLandedCostNoTax(){
        if(this.tax_type == 'V'){
          var x = this.product.landed_cost;
          var z = this.default_vat_rate;
          var y = 0;

          if(x > 0){
            y = x / ( 1 + (z / 100));
          }

          this.product.landed_cost_no_vat = this.fixedCostDecimal(y);
        } else {
          this.product.landed_cost_no_vat = this.product.landed_cost;
        }

        if (this.product.markup_percent != 0 && this.product.markup_percent != ""){
          this.computePrice(null);
        }
      },
      computePrice(e) {
        let name;
        if (e == null){
          name = e;
        } else {
          name = e.target.name;
        }

        let y = 0;
        let z = 0;
        if (this.enable_auto_compute_price_on_markup == true){

          if (name == 'special'){
            y = this.markup_special_price;
            if (this.product.special_price == "") {
              z = this.baseComputation(y);
              this.product.special_price = z;
            }
          } else if (name == 'least'){
            y = this.markup_least_price;
            if (this.product.least_price == "") {
              z = this.baseComputation(y);
              this.product.least_price = z;
            }
          } else if (name == 'wholesale') {
            y = this.markup_wholesale_price;
            if (this.product.wholesale_price == "") {
              z = this.baseComputation(y);
              this.product.wholesale_price = z;
            }
          } else if (name == 'price4') {
            y = this.markup_price4;
            if (this.product.price4 == "") {
              z = this.baseComputation(y);
              this.product.price4 = z;
            }
          } else if (name == 'price5') {
            y = this.markup_price5;
            if (this.product.price5 == "") {
              z = this.baseComputation(y);
              this.product.price5 = z;
            }
          } else {
            y = this.product.markup_percent;
            if (this.product.retail_price == "") {
              z = this.baseComputation(y);
              this.product.retail_price = z;
            }
          }
        }
      },
      baseComputation(y){
        var x = this.product.landed_cost;
        var z = 0;
        var based_on = this.markup_computation;

        if(based_on == "1"){
          z = x / (1 - ( y / 100));
        } else {
          z = x * ( 1 + ( y / 100));
        }

        var val = Number(z);
        var fixedVal = val.toFixed(6); //to eliminate float errors
        
        var cons = Math.ceil(fixedVal / this.markup_roundup) * this.markup_roundup;
        var fixedCons = this.fixedCostDecimal(cons);

        return fixedCons;
      },
      changeAmount(e) {
        let name = e.target.name
        let x = 0;
        if (name == 'original'){
          x = this.fixedCostDecimal(this.product.original_cost);
          this.product.original_cost = x;

          if(this.product.ordering_cost == "") {
            this.product.original_cost = this.product.original_cost;
            this.product.ordering_cost = this.product.original_cost;
          }
        } else if (name == 'ordering'){
          x = this.fixedCostDecimal(this.product.ordering_cost);
          this.product.ordering_cost = x;

          if(this.product.original_cost == "") {
            this.product.original_cost = this.product.ordering_cost;
          }
        } else if (name == 'landed') {
          x = this.fixedCostDecimal(this.product.landed_cost);
          this.product.landed_cost = x;
          this.computeLandedCostNoTax();
        }
      },
      fixedCostDecimal(value){
        let val = Number(value)
        let x = val.toFixed(this.cost_decimal_places);
        return x;
      },
      getUnitCode: async function(value) {
        var unit = await HTTPRequest.getRequest(this.endPoint + 'units/'+ value, null);
        this.product.unit_code = unit.name;
        this.updateKey++;

        if(this.productType == 'P'){
          this.constructName("name");
        
          if (this.package_name_format_base == true){
            this.constructName("short_name");
          }
        }
        
      },
      getIntroDate: async function(value) {
        var product_line = await HTTPRequest.getRequest(this.endPoint + 'product_lines/'+ value, null);
        if (product_line.intro_at == null){
          this.product.intro_date = null
        } else {
          this.product.intro_date = moment(product_line.intro_at);
        }
        this.updateKey++;
      },
      onSetVatex(e){
        let discount = e.target.value
        let name = e.target.name
        if (discount >= 20){
          if (name == 'sc_discount'){
            this.product.is_senior_vatex = true;
            this.product.is_senior_nolimit = true;
          } else {
            this.product.is_pwd_vatex = true;
            this.product.is_pwd_nolimit = true;
          }
        } else {
          if (name == 'sc_discount'){
            this.product.is_senior_vatex = false;
            this.product.is_senior_nolimit = false;
          } else {
            this.product.is_pwd_vatex = false;
            this.product.is_pwd_nolimit = false;
          }
        }
      },
      updateIntroDate(date){
        if(date == null){
          this.product.intro_date = null
        } else {
          this.product.intro_date = date;
        }
        this.updateKey++;
      },
      updateRefDate(date){
        if(date == null){
          this.product.reference_date = null
        } else {
          this.product.reference_date = date;
        }
        this.updateKey++;
      },
      handleClick(e) {
        if(this.activeKey == '1'){
          this.basicKey = e.key;
          this.basicSelectedKeys = [e.key]
        } else {
          this.advanceKey = e.key;
          this.basicSelectedKeys = [e.key]
        }
      },
      filter(inputValue, path) {
        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      sort(data){
        data.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      },
      updateParams(value) {
        if(value.length == 5){
          Object.assign(this.product, {
            division_id: value[1],
            department_id: value[2],
            section_id: value[3],
            category_id: value[4]
          })
        } else {
          Object.assign(this.product, {
            division_id: 0,
            department_id: 0,
            section_id: 0,
            category_id: 0
          })
        }
      },
      onSelectChange(selectedRowKeys) {
        if(this.productType == 'P'){
          this.selectedRowKeys = this.selectedRowKeys;
        } else {
          this.selectedRowKeys = selectedRowKeys;
        }
      },
      openNotificationWithIcon(type, num, field) {
        if(num == 1){
          return 'This product has Zero ' + field;
        } else if(num == 2){
          return 'This product has Zero ' + field;
        } else if(num == 3){
          return field + ' is below Cost (landed)';
        } else if(num == 4){
          return field + ' has changed and it contains a package';
        }
      },
      limit(e){
        let dimension = e.target.value
        let max_chars = 20;
        if(dimension.length > max_chars) {
          this.product[e.target.name] = dimension.substr(0, max_chars);
        }
      },
      updateAlternateSupplier: async function (value) {
        var suppliers = await HTTPRequest.getRequest(this.endPoint + "suppliers/get_valid_suppliers?supplier_id=" + value, null);
        this.supplierOptions = suppliers;
        this.sort(this.supplierOptions);

        this.alternate_supplier_id = null;
      },

      // product series methods
      updateProductSeriesIntroDate(date){
        this.product_series.intro_date = moment(date).format("MMMM DD, YYYY")
        if(this.productseriesButton == 'delete'){
          this.productseriesButton = 'add'
        }
      },

      updateProductSeriesSeriesDate(date){
        this.product_series.series_date = moment(date).format("MMMM DD, YYYY");
        
        // use for changing delete button on product_series 
        if(this.productseriesButton == 'delete'){
          this.productseriesButton = 'add'
        }
      },

      changeProductSeriesButton(record) {
        return {
          on: {
            click: event => {
              this.productseriesButton = 'delete'
              this.productseriesKey = record.key;
            }
          }
        };
      },

      productseriesDelete(key){
        const dataSource = [...this.productseriesData];
        this.productseriesData = dataSource.filter(item => item.key !== key);
        this.productseriesButton = 'add';
      },

      productseriesHandleAdd: async function() {
        const productseriesCount = this.productseriesCount;

        this.tableErrors = [];
        const product_series = this.product_series;
        
        // product series validation
        
        if(!this.product_series.series_name){
          this.tableErrors.push("Series Name Required");
        }

        if(!product_series.intro_date){
          this.tableErrors.push("Intro Date Rrequired");
        }
        
        if(!product_series.series_date){
          this.tableErrors.push("Series Date Required");
        }

        if(this.productseriesData.find(object => object.series_name.toLowerCase() === product_series.series_name.toLowerCase())) {
          this.tableErrors.push("Series Name already exists");
        }

        if(this.tableErrors.length <= 0){
          product_series.key = productseriesCount;
          product_series.status = 'A'
          this.productseriesData.push({...product_series});
          
          this.productseriesCount = productseriesCount + 1;
          this.product_series = [];
        }

      },
      // end of product series methods

      create: async function () {
        this.spinning = true;
        if(!this.validateForm()) {
        
          this.product.tax_type = this.tax_type;
          this.product.product_type = "R"
          //removal of CLP points
          if(this.product.is_reward_item == false){
            this.product.reward_required_points = 0;
          }

          //removal of Commissions
          if(this.product.is_enable_sales_commission == false){
            this.product.salesman_commission = 0;
          }

          if(this.product.is_enable_supplier_commission == false){
            this.product.supplier_commission = 0;
          }

          //for image
          let file = null;
          if(this.fileList.length > 0){
            if (this.fileList[0].response == undefined){
              file = this.fileList[0].name
            } else {
              file = this.fileList[0].response
            }
          }
          this.product.filename = file
          
          //for properties
          if (this.product_properties.property_id != undefined){
            var property_ids = this.product_properties.property_id
            var product_properties = []
            property_ids.forEach(element => {
              product_properties.push({
                property_id: element,
                status: 'A'
              });
            });
            this.product.product_properties = product_properties
          }

          if (this.product.product_type == 'V'){
            this.product.is_inventory = false;
          }
          
          //for alternate supplier
          if (this.data.length > 0){
            var supplier_products = this.data
            this.product.supplier_products = supplier_products
          }

          //for alternate barcode
          if (this.barcodeData.length > 0){
            var alternate_barcodes = this.barcodeData
            this.product.product_barcodes = alternate_barcodes
          }

          // for product series 
          if (this.productseriesData.length > 0){
            var product_series = this.productseriesData
            this.product.product_series = product_series
          }

          //for shelf code
          if (this.shelfData.length > 0){
            var site_shelf_codes = this.shelfData
            this.product.site_shelf_codes = site_shelf_codes
          }

          //for reorder
          if (this.reorderData.length > 0){
            var site_reorders = this.reorderData
            this.product.site_reorders = site_reorders
          }

          //   for recipe
          if (this.yieldData.length > 0){
            this.product.finished_product_id = this.yieldData[0].regular_product_id
            this.product.yield_quantity = this.yieldData[0].quantity
            this.product.tolerance_quantity = this.yieldData[0].tolerance
          }

          //for site_products
          var site_ids = this.selectedRowKeys
          var site_products = []
          site_ids.forEach(element => {
            site_products.push({
              site_id: element,
              status: 'A'
            });
          });
          this.product.site_products = site_products

          this.product.site_prices = this.priceData
          
          let product_compositions = []
          product_compositions = this.kitData
          this.product.product_compositions = product_compositions  
          //save kitSettings
          var userSettingHash = {}
          var userId = secureStorage.getItem("userId")
          userSettingHash["recompute_kit_cost"] = this.recompute_cost
          userSettingHash["recompute_kit_price"] = this.recompute_price  
          var response;
          response = await HTTPRequest.getRequest(this.endPoint + "/user_settings?module_name=kit&user_id=" + userId ,null)
          if (response.data.length == 0) {
            var createParams = {
              user_setting: {
                module_name: "kit",
                user_id: userId,
                settings_json: JSON.stringify(userSettingHash)
              }
            }
            await HTTPRequest.postRequest(this.endPoint + "/user_settings", null, createParams)
          } else {
            var updateParams = {
              user_setting: {
                module_name: "kit",
                user_id: userId,
                settings_json: JSON.stringify(userSettingHash)
              }
            }
            await HTTPRequest.putRequest(this.endPoint + "/user_settings/" + response.data[0].id, null, updateParams)
          }


          var product_hash = {}
          product_hash.product = this.product
          var post_request = await HTTPRequest.postRequest(this.endPoint + 'products', null, product_hash)
          if (post_request == undefined) {
            this.$emit('refreshPage', event)
          } else {
            if (post_request["error"] == undefined) {
              this.$emit('refreshPage', event)
            } else {
              this.errors = post_request["error"].split(",")
            }
          }
        }
        document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
        this.spinning = false;
      },
      update: async function () {
        this.spinning = true;
        if(!this.validateForm()) {
          //removal of CLP points
          
          this.product.tax_type = this.tax_type;
          
          if(this.product.is_reward_item == false){
            this.product.reward_required_points = 0;
          }

          //removal of Commissions
          if(this.product.is_enable_sales_commission == false){
            this.product.salesman_commission = 0;
          }
          
          if(this.product.is_enable_supplier_commission == false){
            this.product.supplier_commission = 0;
          }

          if(this.change_price_cost_package_on_regular_update == true){
            this.product.change_price_cost_package_on_regular_update = this.change_price_cost_package_on_regular_update;
          }

          let file = null;
          if(this.fileList.length > 0){
            if (this.fileList[0].response == undefined){
              file = this.fileList[0].name
            } else {
              file = this.fileList[0].response
            }
          }
          this.product.filename = file

          //for properties
          if (this.product_properties.property_id != undefined){
            var property_ids = this.product_properties.property_id
            var product_properties = []
            property_ids.forEach(element => {
              product_properties.push({
                property_id: element,
                status: 'A'
              });
            });
            this.product.product_properties = product_properties
          }

          if (this.product.product_type == 'V'){
            this.product.is_inventory = false;
          }

          //for alternate supplier
          if (this.data.length > 0){
            var supplier_products = this.data
            this.product.supplier_products = supplier_products
          }

          //for alternate barcode
          if (this.barcodeData.length > 0){
            var alternate_barcodes = this.barcodeData
            this.product.product_barcodes = alternate_barcodes
          }

          // for product series update
          if (this.productseriesData.length > 0){
            var product_series = this.productseriesData
            this.product.product_series = product_series
          }


          //for shelf code
          if (this.shelfData.length > 0){
            var site_shelf_codes = this.shelfData
            this.product.site_shelf_codes = site_shelf_codes
          }

          //for reorder
          if (this.reorderData.length > 0){
            var site_reorders = this.reorderData
            this.product.site_reorders = site_reorders
          }

          //for site_products
          var site_ids = this.selectedRowKeys
          var site_products = []
          site_ids.forEach(element => {
            site_products.push({
              site_id: element,
              status: 'A'
            });
          });
          this.product.site_products = site_products

          this.product.site_prices = this.priceData

          //   for recipe
          if (this.yieldData.length > 0){
            this.product.finished_product_id = this.yieldData[0].regular_product_id
            this.product.yield_quantity = this.yieldData[0].quantity
            this.product.tolerance_quantity = this.yieldData[0].tolerance
          }

            let product_compositions = this.kitData
            this.product.product_compositions = product_compositions

            //save kitSettings
            var userSettingHash = {}
            var userId = secureStorage.getItem("userId")
            userSettingHash["recompute_kit_cost"] = this.recompute_cost
            userSettingHash["recompute_kit_price"] = this.recompute_price

            var response;
            response = await HTTPRequest.getRequest(this.endPoint + "/user_settings?module_name=kit&user_id=" + userId ,null)
            if (response.data.length == 0) {
              var createParams = {
                user_setting: {
                  module_name: "kit",
                  user_id: userId,
                  settings_json: JSON.stringify(userSettingHash)
                }
              }
              await HTTPRequest.postRequest(this.endPoint + "/user_settings", null, createParams)
            } else {
              var updateParams = {
                user_setting: {
                  module_name: "kit",
                  user_id: userId,
                  settings_json: JSON.stringify(userSettingHash)
                }
              }
              await HTTPRequest.putRequest(this.endPoint + "/user_settings/" + response.data[0].id, null, updateParams)
            }
          
          var product_hash = {}
          product_hash.product = this.product
          var put_request = await HTTPRequest.putRequest(this.endPoint + 'products/' + this.profileId, null, product_hash)
          if (put_request == undefined) {
            this.$emit('refreshPage', event)
          } else {
            if (put_request["error"] == undefined) {
              this.$emit('refreshPage', event, 'update')
            } else {
              this.errors = put_request["error"].split(",")
            }
          }
        }
        document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
        this.spinning = false;
      },
      showModal: async function() {
        this.checkWarning();

        if(this.warnings.length > 0){
          this.modalVisible = true;
        } else {
          if(this.profileId == 0){
            this.create();
          } else {
            this.update();
          }
        }
      },
      handleOk: async function() {
        if(this.profileId == 0){
          this.create();
        } else {
          this.update();
        }
        this.modalVisible = false;
      },
       // will set a class: ant-menu-item-selected on menu item
    selectedBasicKey(key){
      if(this.basicSelectedKeys[0] == key){
        return 'ant-menu-item-selected'
      }
    },
    selectedAdvanceKey(key){
      if(this.advanceSelectedKeys[0] == key){
        return 'ant-menu-item-selected'
      }
    },
    // show the correct tab to display when Back/Next button is click
    handleBackButton(){
      let tempBasicKey = Number(this.basicKey);
      let tempAdvanceKey = Number(this.advanceKey);

      if (this.activeKey == '1'){
        if(tempBasicKey > 1){
          tempBasicKey -= 1;
          this.basicSelectedKeys  = [tempBasicKey]
          this.basicKey = tempBasicKey.toString();
        }
      } else if(this.activeKey == '2'){
        if(tempAdvanceKey > 1){
         tempAdvanceKey -= 1;
         this.advanceSelectedKeys  = [tempAdvanceKey]
         this.advanceKey = tempAdvanceKey.toString();
        }
      }
    },

    handleNextButton(){
      let tempBasicKey = Number(this.basicKey);
      let tempAdvanceKey = Number(this.advanceKey);

      if (this.activeKey == '1'){
         if(tempBasicKey < 3){
          tempBasicKey += 1;
          this.basicSelectedKeys  = [tempBasicKey]
          this.basicKey = tempBasicKey.toString();
        }
      } else if(this.activeKey == '2'){
        if(tempAdvanceKey < 11){
         tempAdvanceKey += 1;
         this.advanceSelectedKeys  = [tempAdvanceKey]
         this.advanceKey = tempAdvanceKey.toString(); 
        }
      }
    },
    }
  }
</script>

<style scope>
  .ant-table-fixed-header .ant-table-scroll .ant-table-header {
    overflow: hidden;
  }

  .ant-collapse>.ant-collapse-item-active>.ant-collapse-header {
    background-color: #32325d;
    color: white;
  }

  .ant-menu-inline,
  .ant-menu-vertical,
  .ant-menu-vertical-left {
    border-right: 0px;
  }

  /* you can make up upload button and sample style by using stylesheets */
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .editable-row-operations a {
    margin-right: 8px;
  }
</style>
